import { GraphQLResolveInfo, GraphQLScalarType, GraphQLScalarTypeConfig } from 'graphql';
import { MedicalInstitution, MedicalInstitutionDetail } from '../../backend/src/models/medical-institution';
import { MedicalInstitutionMember } from '../../backend/src/models/medical-institution-member';
import { Contract, CancelContractPayload, AdminNotification, AdminNotificationsResult } from '../../backend/src/infrastructure/aps-service/interface';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type RequireFields<T, K extends keyof T> = Omit<T, K> & { [P in K]-?: NonNullable<T[P]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Date: { input: any; output: any; }
  Json: { input: any; output: any; }
  Upload: { input: any; output: any; }
};

export type GQLActiveContractExistsError = {
  __typename?: 'ActiveContractExistsError';
  activeContractCount: Scalars['Int']['output'];
  code: Scalars['String']['output'];
  medicalInstitutionId: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type GQLBillingAccount = {
  __typename?: 'BillingAccount';
  billingAccountId: Scalars['String']['output'];
  contactEmailAddress: Scalars['String']['output'];
  contactName: Scalars['String']['output'];
  department?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  sendEmail: Scalars['Boolean']['output'];
  sendMail: Scalars['Boolean']['output'];
};

export type GQLCancelContractInput = {
  contractId: Scalars['ID']['input'];
};

export type GQLCancelContractPayload = {
  __typename?: 'CancelContractPayload';
  contract: GQLContract;
};

export type GQLCancelMedicalInstitutionInput = {
  medicalInstitutionId: Scalars['ID']['input'];
};

export type GQLCancelMedicalInstitutionPayload = GQLActiveContractExistsError | GQLCancelMedicalInstitutionSuccess;

export type GQLCancelMedicalInstitutionSuccess = {
  __typename?: 'CancelMedicalInstitutionSuccess';
  medicalInstitution: GQLMedicalInstitution;
};

export type GQLClientCertificate = {
  __typename?: 'ClientCertificate';
  createdAt: Scalars['Date']['output'];
  domain: Scalars['String']['output'];
  downloadUrl?: Maybe<Scalars['String']['output']>;
  expiresAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  isUsed: Scalars['Boolean']['output'];
  medicalInstitution: GQLMedicalInstitution;
  name: Scalars['String']['output'];
  password?: Maybe<Scalars['String']['output']>;
  serialNumber?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['Date']['output'];
};

export type GQLContract = {
  __typename?: 'Contract';
  createdAt: Scalars['Date']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  initial: Scalars['Boolean']['output'];
  manager?: Maybe<GQLContractManager>;
  notificationRecipients?: Maybe<Array<GQLContractNotificationRecipient>>;
  pdt: GQLPdt;
  responsiblePerson?: Maybe<GQLContractResponsiblePerson>;
};

export type GQLContractManager = {
  __typename?: 'ContractManager';
  department?: Maybe<Scalars['String']['output']>;
  emailAddress?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  welcomeMailSentAt?: Maybe<Scalars['Date']['output']>;
};

/** 連絡通知先 */
export type GQLContractNotificationRecipient = {
  __typename?: 'ContractNotificationRecipient';
  emailContact: GQLEmailContact;
  id: Scalars['ID']['output'];
};

/** 製品管理責任者 */
export type GQLContractResponsiblePerson = {
  __typename?: 'ContractResponsiblePerson';
  emailContact: GQLEmailContact;
  id: Scalars['ID']['output'];
  welcomeMailSentAt?: Maybe<Scalars['Date']['output']>;
};

export type GQLCreateCsNotificationImageUploadUrlInput = {
  contentType: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
};

export type GQLCreateCsNotificationImageUploadUrlPayload = GQLCsNotificationImageUploadUrl | GQLCsNotificationImageUploadUrlError;

export type GQLCreateCsNotificationInput = {
  body: Scalars['String']['input'];
  endAt?: InputMaybe<Scalars['Date']['input']>;
  medicalInstitutionIds: Array<Scalars['String']['input']>;
  pdtCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  positions: Array<GQLMedicalInstitutionMemberPosition>;
  roles: Array<GQLMedicalInstitutionMemberRole>;
  startFrom: Scalars['Date']['input'];
  title: Scalars['String']['input'];
};

export type GQLCreateDeliveryOrderInput = {
  address: Scalars['String']['input'];
  clientCertificatePassword?: InputMaybe<Scalars['String']['input']>;
  deliveryDate?: InputMaybe<Scalars['String']['input']>;
  deliveryTimeCode: GQLDeliveryTimeCode;
  name: Scalars['String']['input'];
  orderClassCode: GQLOrderClassCode;
  phoneNumber: Scalars['String']['input'];
  postalCode: Scalars['String']['input'];
  prescriptionCodeId?: InputMaybe<Scalars['String']['input']>;
  products: Array<GQLDeliveryProductsInput>;
};

export type GQLCreatePdtDocumentInput = {
  enableFlag?: InputMaybe<Scalars['Boolean']['input']>;
  isUrlS3Path: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  pdtId: Scalars['String']['input'];
  url: Scalars['String']['input'];
  version?: InputMaybe<Scalars['Int']['input']>;
};

export type GQLCsNotification = {
  __typename?: 'CsNotification';
  body: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  endAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  /** 削除可能かどうか（SYSTEM作成・規約同意お知らせはfalse） */
  isDeletable: Scalars['Boolean']['output'];
  /** 編集可能かどうか（SYSTEM作成・規約同意お知らせはfalse） */
  isEditable: Scalars['Boolean']['output'];
  medicalInstitutionIds: Array<Scalars['String']['output']>;
  pdtCodes: Array<Scalars['String']['output']>;
  positions: Array<GQLMedicalInstitutionMemberPosition>;
  roles: Array<GQLMedicalInstitutionMemberRole>;
  /** お知らせの作成元 */
  source: GQLNotificationSource;
  startFrom: Scalars['Date']['output'];
  /**
   * 規約同意お知らせの場合の規約バージョンID（通常のお知らせはnull）
   * 非nullの場合、削除・一部データの編集を不可とする
   */
  termsVersionId?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
};

export type GQLCsNotificationImageUploadUrl = {
  __typename?: 'CsNotificationImageUploadUrl';
  /** POSTリクエストに含めるフォームフィールド（JSON文字列） */
  fields: Scalars['String']['output'];
  /** S3キー（Markdown内で相対パスとして使用） */
  key: Scalars['String']['output'];
  /** S3へのPresigned POST URL */
  url: Scalars['String']['output'];
};

export type GQLCsNotificationImageUploadUrlError = GQLError & {
  __typename?: 'CsNotificationImageUploadUrlError';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type GQLCsNotificationPayload = {
  __typename?: 'CsNotificationPayload';
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
};

export type GQLCsNotificationsInput = {
  page?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type GQLCsNotificationsPayload = {
  __typename?: 'CsNotificationsPayload';
  notifications: Array<GQLCsNotification>;
  totalCount: Scalars['Int']['output'];
};

export type GQLDeleteCsNotificationError = GQLError & {
  __typename?: 'DeleteCsNotificationError';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type GQLDeleteCsNotificationPayload = GQLDeleteCsNotificationError | GQLDeleteCsNotificationSuccess;

export type GQLDeleteCsNotificationSuccess = {
  __typename?: 'DeleteCsNotificationSuccess';
  /** 削除した通知のID */
  id: Scalars['ID']['output'];
};

export type GQLDeliveryHistory = {
  __typename?: 'DeliveryHistory';
  createdAt: Scalars['Date']['output'];
  deliveryOrder: GQLDeliveryOrder;
  id: Scalars['ID']['output'];
  outputAt?: Maybe<Scalars['Date']['output']>;
  product: GQLProduct;
  serialNumber?: Maybe<Scalars['String']['output']>;
  shipConfirmedAt?: Maybe<Scalars['String']['output']>;
  slipNumber?: Maybe<Scalars['String']['output']>;
};

export type GQLDeliveryOrder = {
  __typename?: 'DeliveryOrder';
  address: Scalars['String']['output'];
  clientCertificatePassword?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  deliveryDate?: Maybe<Scalars['String']['output']>;
  deliveryHistory: Array<GQLDeliveryHistory>;
  deliveryProducts: Array<GQLDeliveryProducts>;
  deliveryStatus: GQLDeliveryStatus;
  deliveryTime: GQLDeliveryTime;
  id: Scalars['ID']['output'];
  isDummy: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  orderClass: GQLOrderClass;
  phoneNumber: Scalars['String']['output'];
  postalCode: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
};

export type GQLDeliveryOrderField = {
  __typename?: 'DeliveryOrderField';
  address: Scalars['String']['output'];
  deliveryDate?: Maybe<Scalars['Date']['output']>;
  deliveryHistory: Array<GQLDeliveryHistory>;
  deliveryProducts: Array<GQLDeliveryProducts>;
  deliveryStatus: GQLDeliveryStatus;
  deliveryTime: GQLDeliveryTime;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  phoneNumber: Scalars['String']['output'];
  postalCode: Scalars['String']['output'];
};

export type GQLDeliveryProducts = {
  __typename?: 'DeliveryProducts';
  collective: Scalars['Boolean']['output'];
  product: GQLProduct;
  quantity: Scalars['Int']['output'];
  returnQuantity: Scalars['Int']['output'];
};

export type GQLDeliveryProductsInput = {
  collective?: InputMaybe<Scalars['Boolean']['input']>;
  productCode: Scalars['String']['input'];
  quantity: Scalars['Int']['input'];
  returnQuantity?: InputMaybe<Scalars['Int']['input']>;
};

export type GQLDeliveryStatus = {
  __typename?: 'DeliveryStatus';
  code: GQLDeliveryStatusCode;
};

export const enum GQLDeliveryStatusCode {
  Shipped = 'SHIPPED',
  ShippingRequest = 'SHIPPING_REQUEST',
  Unshipped = 'UNSHIPPED'
};

export type GQLDeliveryTime = {
  __typename?: 'DeliveryTime';
  code: GQLDeliveryTimeCode;
  section: Scalars['String']['output'];
};

export const enum GQLDeliveryTimeCode {
  Yt0000 = 'YT0000',
  Yt0812 = 'YT0812',
  Yt1416 = 'YT1416',
  Yt1618 = 'YT1618',
  Yt1820 = 'YT1820',
  Yt2021 = 'YT2021'
};

/** 通知先 */
export type GQLEmailContact = {
  __typename?: 'EmailContact';
  department?: Maybe<Scalars['String']['output']>;
  emailAddress: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

/** 通知先（製品管理責任者・連絡通知先）が紐づくPDT */
export type GQLEmailContactPdt = {
  __typename?: 'EmailContactPdt';
  code: Scalars['String']['output'];
  iconPath: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

/**
 * 通知先（EmailContact）の集約情報
 * 製品管理責任者・連絡通知先として紐づいているPDTを集約して返す
 */
export type GQLEmailContactSummary = {
  __typename?: 'EmailContactSummary';
  department?: Maybe<Scalars['String']['output']>;
  emailAddress: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  notificationRecipients?: Maybe<Array<Maybe<GQLEmailContactPdt>>>;
  responsiblePersons?: Maybe<Array<Maybe<GQLEmailContactPdt>>>;
};

export type GQLError = {
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type GQLForceCancelPrescriptionError = GQLError & {
  __typename?: 'ForceCancelPrescriptionError';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  prescriptionCode: Scalars['String']['output'];
};

export type GQLForceCancelPrescriptionInput = {
  prescriptionCode: Scalars['String']['input'];
};

export type GQLForceCancelPrescriptionPayload = GQLForceCancelPrescriptionError | GQLPrescription;

export type GQLHtUser = {
  __typename?: 'HTUser';
  appName: Scalars['String']['output'];
  birthday?: Maybe<Scalars['Date']['output']>;
  bloodPressureMeasurementRate?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  maskedDetail?: Maybe<Scalars['Json']['output']>;
  medicalInstitutionId?: Maybe<Scalars['String']['output']>;
  medicalInstitutionName?: Maybe<Scalars['String']['output']>;
  nickname?: Maybe<Scalars['String']['output']>;
  pdtCode?: Maybe<Scalars['String']['output']>;
  pdtId?: Maybe<Scalars['String']['output']>;
  prescribedAt?: Maybe<Scalars['Date']['output']>;
  prescription?: Maybe<GQLPrescription>;
  prescriptionCode: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type GQLHtVerifyCode = {
  __typename?: 'HTVerifyCode';
  code: Scalars['String']['output'];
  permanent: Scalars['Boolean']['output'];
};

export type GQLHaudyUser = {
  __typename?: 'HaudyUser';
  activatedAt?: Maybe<Scalars['Date']['output']>;
  appName: Scalars['String']['output'];
  birthMonth?: Maybe<Scalars['Date']['output']>;
  drinkingRecordRate?: Maybe<Scalars['Float']['output']>;
  firstConsultationAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  latestConsultationAt?: Maybe<Scalars['Date']['output']>;
  medicalInstitutionId: Scalars['String']['output'];
  medicalInstitutionName: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  nickname?: Maybe<Scalars['String']['output']>;
  pdtCode?: Maybe<Scalars['String']['output']>;
  pdtId?: Maybe<Scalars['String']['output']>;
  prescribedAt?: Maybe<Scalars['Date']['output']>;
  prescriptionCode: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type GQLListHtUser = {
  __typename?: 'ListHTUser';
  appName: Scalars['String']['output'];
  birthday?: Maybe<Scalars['Date']['output']>;
  bloodPressureMeasurementRate?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['Date']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  medicalInstitutionId?: Maybe<Scalars['String']['output']>;
  medicalInstitutionName?: Maybe<Scalars['String']['output']>;
  nickname?: Maybe<Scalars['String']['output']>;
  pdtCode?: Maybe<Scalars['String']['output']>;
  pdtId?: Maybe<Scalars['String']['output']>;
  prescribedAt?: Maybe<Scalars['Date']['output']>;
  prescriptionCode: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type GQLListHaudyUser = {
  __typename?: 'ListHaudyUser';
  activatedAt?: Maybe<Scalars['Date']['output']>;
  appName: Scalars['String']['output'];
  birthMonth?: Maybe<Scalars['Date']['output']>;
  firstConsultationAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  latestConsultationAt?: Maybe<Scalars['Date']['output']>;
  nickname?: Maybe<Scalars['String']['output']>;
  pdtCode?: Maybe<Scalars['String']['output']>;
  pdtId?: Maybe<Scalars['String']['output']>;
  prescribedAt?: Maybe<Scalars['Date']['output']>;
  prescriptionCode: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type GQLListScUser = {
  __typename?: 'ListSCUser';
  appName: Scalars['String']['output'];
  birthday?: Maybe<Scalars['Date']['output']>;
  coCheckerSerial?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  prescribedAt?: Maybe<Scalars['Date']['output']>;
  prescriptionCode: Scalars['String']['output'];
  registeredAt?: Maybe<Scalars['Date']['output']>;
};

export type GQLMedicalInstitution = {
  __typename?: 'MedicalInstitution';
  city: Scalars['String']['output'];
  createdAt: Scalars['Date']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  isDummy?: Maybe<Scalars['Boolean']['output']>;
  name: Scalars['String']['output'];
  otherAddress: Scalars['String']['output'];
  phoneNumber: Scalars['String']['output'];
  postalCode: Scalars['String']['output'];
  prefecture: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
};

export type GQLMedicalInstitutionDetail = {
  __typename?: 'MedicalInstitutionDetail';
  billingAccount?: Maybe<GQLBillingAccount>;
  city: Scalars['String']['output'];
  clientCertificate: GQLClientCertificate;
  createdAt: Scalars['Date']['output'];
  deletedAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  isDummy?: Maybe<Scalars['Boolean']['output']>;
  isSetupFinished: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  otherAddress: Scalars['String']['output'];
  phoneNumber: Scalars['String']['output'];
  postalCode: Scalars['String']['output'];
  prefecture: Scalars['String']['output'];
  updatedAt: Scalars['Date']['output'];
};

export type GQLMedicalInstitutionMember = {
  __typename?: 'MedicalInstitutionMember';
  contracts?: Maybe<Array<GQLMemberContract>>;
  createdAt: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  medicalInstitution: GQLMedicalInstitution;
  name: Scalars['String']['output'];
  position: Array<GQLMedicalInstitutionMemberPosition>;
  role: Array<GQLMedicalInstitutionMemberRole>;
  status: GQLMedicalInstitutionMemberStatus;
};

export const enum GQLMedicalInstitutionMemberPosition {
  Doctor = 'DOCTOR',
  Nurse = 'NURSE',
  Staff = 'STAFF'
};

export const enum GQLMedicalInstitutionMemberRole {
  Admin = 'ADMIN',
  Staff = 'STAFF'
};

export const enum GQLMedicalInstitutionMemberStatus {
  Disabled = 'DISABLED',
  Enabled = 'ENABLED',
  Invited = 'INVITED',
  SecretcodeReissued = 'SECRETCODE_REISSUED'
};

export type GQLMemberContract = {
  __typename?: 'MemberContract';
  id: Scalars['ID']['output'];
  pdt: GQLPdt;
};

export type GQLMutation = {
  __typename?: 'Mutation';
  cancelContract: GQLCancelContractPayload;
  cancelMedicalInstitution: GQLCancelMedicalInstitutionPayload;
  createCsNotification: GQLCsNotificationPayload;
  createCsNotificationImageUploadUrl: GQLCreateCsNotificationImageUploadUrlPayload;
  createDeliveryOrder: GQLDeliveryOrder;
  createPdtDocument: GQLPdtDocument;
  deleteCsNotification: GQLDeleteCsNotificationPayload;
  forceCancelPrescription?: Maybe<GQLForceCancelPrescriptionPayload>;
  noop?: Maybe<GQLNoopPayload>;
  publishHtVerifyCode: GQLHtVerifyCode;
  reissueSecretCode: GQLReissueSecretCodePayload;
  resendWelcomeMail: GQLResendWelcomeMailPayload;
  resendWelcomeMailV2: GQLResendWelcomeMailV2Payload;
  sendUpdatePasswordCompletionEmail?: Maybe<Scalars['Boolean']['output']>;
  updateCsNotification: GQLCsNotificationPayload;
  updateHtUserEmailAddress: GQLHtUser;
  uploadPdtDocument: GQLPdtDocument;
};


export type GQLMutationCancelContractArgs = {
  input: GQLCancelContractInput;
};


export type GQLMutationCancelMedicalInstitutionArgs = {
  input: GQLCancelMedicalInstitutionInput;
};


export type GQLMutationCreateCsNotificationArgs = {
  input: GQLCreateCsNotificationInput;
};


export type GQLMutationCreateCsNotificationImageUploadUrlArgs = {
  input: GQLCreateCsNotificationImageUploadUrlInput;
};


export type GQLMutationCreateDeliveryOrderArgs = {
  input: GQLCreateDeliveryOrderInput;
};


export type GQLMutationCreatePdtDocumentArgs = {
  input: GQLCreatePdtDocumentInput;
};


export type GQLMutationDeleteCsNotificationArgs = {
  id: Scalars['ID']['input'];
};


export type GQLMutationForceCancelPrescriptionArgs = {
  input: GQLForceCancelPrescriptionInput;
};


export type GQLMutationNoopArgs = {
  input?: InputMaybe<GQLNoopInput>;
};


export type GQLMutationPublishHtVerifyCodeArgs = {
  input: GQLVerifyCodeInput;
};


export type GQLMutationReissueSecretCodeArgs = {
  medicalInstitutionMemberId: Scalars['ID']['input'];
};


export type GQLMutationResendWelcomeMailArgs = {
  input: GQLResendWelcomeMailInput;
};


export type GQLMutationResendWelcomeMailV2Args = {
  input: GQLResendWelcomeMailV2Input;
};


export type GQLMutationSendUpdatePasswordCompletionEmailArgs = {
  input: GQLSendUpdatePasswordInput;
};


export type GQLMutationUpdateCsNotificationArgs = {
  input: GQLUpdateCsNotificationInput;
};


export type GQLMutationUpdateHtUserEmailAddressArgs = {
  input: GQLUpdateHtUserEmailAddressInput;
};


export type GQLMutationUploadPdtDocumentArgs = {
  input: GQLUploadPdtDocumentInput;
};

export type GQLNode = {
  id: Scalars['ID']['output'];
};

export type GQLNoopInput = {
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

export type GQLNoopPayload = {
  __typename?: 'NoopPayload';
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** お知らせの作成元 */
export const enum GQLNotificationSource {
  /** Admin API / CS-SYSTEMから手動作成 */
  Admin = 'ADMIN',
  /** APSが自動作成（メンバー招待、契約追加、初回処方など） */
  System = 'SYSTEM'
};

export type GQLOrderClass = {
  __typename?: 'OrderClass';
  code: GQLOrderClassCode;
  name: Scalars['String']['output'];
};

export const enum GQLOrderClassCode {
  MedicalInstitutionReplacementShipping = 'MEDICAL_INSTITUTION_REPLACEMENT_SHIPPING',
  MedicalInstitutionShipping = 'MEDICAL_INSTITUTION_SHIPPING',
  PatientReplacementShipping = 'PATIENT_REPLACEMENT_SHIPPING',
  PatientShipping = 'PATIENT_SHIPPING'
};

export type GQLPdt = {
  __typename?: 'Pdt';
  category?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Date']['output'];
  description: Scalars['String']['output'];
  enableFlag: Scalars['Boolean']['output'];
  hasTentativePrescriptions: Scalars['Boolean']['output'];
  iconPath: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  officialUrl: Scalars['String']['output'];
  pdtDocuments: Array<GQLPdtDocument>;
  siteUrl: Scalars['String']['output'];
  supportUrl: Scalars['String']['output'];
  vendor: GQLVendor;
};

export type GQLPdtDocument = {
  __typename?: 'PdtDocument';
  createdAt: Scalars['Date']['output'];
  enableFlag: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  isUrlS3Path: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  url: Scalars['String']['output'];
  version: Scalars['Int']['output'];
};

export type GQLPrescription = {
  __typename?: 'Prescription';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  prescriptionCureAppPdtCode?: Maybe<GQLPrescriptionCureAppPdtCode>;
};

export type GQLPrescriptionByPrescriptionCodePayload = {
  __typename?: 'PrescriptionByPrescriptionCodePayload';
  appName: Scalars['String']['output'];
  birthday?: Maybe<Scalars['Date']['output']>;
  code: Scalars['String']['output'];
  codeId: Scalars['String']['output'];
  codeStatus: GQLPrescriptionCodeStatusLabelForCsSystem;
  createdAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  medicalInstitutionName: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export const enum GQLPrescriptionCodeStatusLabel {
  Expired = 'EXPIRED',
  Fulfilled = 'FULFILLED',
  Suspended = 'SUSPENDED',
  Tentative = 'TENTATIVE',
  Terminated = 'TERMINATED',
  Unused = 'UNUSED',
  Used = 'USED'
};

export const enum GQLPrescriptionCodeStatusLabelForCsSystem {
  Canceled = 'CANCELED',
  Expired = 'EXPIRED',
  Fulfilled = 'FULFILLED',
  Suspended = 'SUSPENDED',
  Tentative = 'TENTATIVE',
  Terminated = 'TERMINATED',
  Unused = 'UNUSED',
  Used = 'USED'
};

export type GQLPrescriptionCureAppPdtCode = {
  __typename?: 'PrescriptionCureAppPdtCode';
  activationLimit?: Maybe<Scalars['String']['output']>;
  canceledStatus?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  pdtCode?: Maybe<Scalars['String']['output']>;
  pdtCodeId: Scalars['String']['output'];
  status?: Maybe<Scalars['String']['output']>;
  statusLabel?: Maybe<GQLPrescriptionCodeStatusLabel>;
  statusLabelForCsSystem?: Maybe<GQLPrescriptionCodeStatusLabelForCsSystem>;
};

export type GQLPrescriptionWithDeletedByPrescriptionCodeIdPayload = {
  __typename?: 'PrescriptionWithDeletedByPrescriptionCodeIdPayload';
  birthday?: Maybe<Scalars['Date']['output']>;
  contract: GQLContract;
  createdAt?: Maybe<Scalars['Date']['output']>;
  id: Scalars['ID']['output'];
  medicalInstitutionMember: GQLMedicalInstitutionMember;
  name?: Maybe<Scalars['String']['output']>;
  prescriptionCureAppPdtCode?: Maybe<GQLPrescriptionCureAppPdtCode>;
};

export type GQLProduct = {
  __typename?: 'Product';
  code: Scalars['String']['output'];
  description: Scalars['String']['output'];
  name: Scalars['String']['output'];
  productClass: GQLProductClass;
  productSets: Array<GQLProductSet>;
  receiptClass: GQLReceiptClass;
  shippingDeadlineAdjustmentClass: GQLShippingDeadlineAdjustmentClass;
  shippingDeadlineManagementClass: GQLShippingDeadlineManagementClass;
  shippingDeadlineOffsetPeriod: Scalars['Int']['output'];
  stockManagementClass: GQLStockManagementClass;
  unitSize: Scalars['Int']['output'];
};

export type GQLProductClass = {
  __typename?: 'ProductClass';
  code: GQLProductClassCode;
};

export const enum GQLProductClassCode {
  Set = 'SET',
  Single = 'SINGLE'
};

export type GQLProductSet = {
  __typename?: 'ProductSet';
  childProduct: GQLProduct;
  product: GQLProduct;
};

export type GQLQuery = {
  __typename?: 'Query';
  clientCertificate?: Maybe<GQLClientCertificate>;
  contracts: Array<GQLContract>;
  contractsIncludingCanceled: Array<GQLContract>;
  csNotification: GQLCsNotification;
  csNotifications: GQLCsNotificationsPayload;
  deliveryOrder?: Maybe<GQLDeliveryOrder>;
  deliveryOrders: Array<GQLDeliveryOrder>;
  deliveryOrdersWithKeywords: Array<GQLDeliveryOrder>;
  emailContactSummariesByMedicalInstitutionId: Array<GQLEmailContactSummary>;
  haudyUser?: Maybe<GQLHaudyUser>;
  haudyUsers: Array<GQLListHaudyUser>;
  htUser: GQLHtUser;
  htUsers: Array<GQLListHtUser>;
  medicalInstitutionDetail?: Maybe<GQLMedicalInstitutionDetail>;
  medicalInstitutionMembersByMedicalInstitutionId: Array<GQLMedicalInstitutionMember>;
  medicalInstitutions: Array<GQLMedicalInstitution>;
  node?: Maybe<GQLNode>;
  pdt: GQLPdt;
  pdts: Array<GQLPdt>;
  prescriptionByPrescriptionCode?: Maybe<GQLPrescriptionByPrescriptionCodePayload>;
  prescriptionWithDeletedByPrescriptionCodeId?: Maybe<GQLPrescriptionWithDeletedByPrescriptionCodeIdPayload>;
  previewCsNotificationMarkdown: Scalars['String']['output'];
  products: Array<GQLProduct>;
  scUser: GQLScUser;
  scUsers: Array<GQLListScUser>;
};


export type GQLQueryClientCertificateArgs = {
  domain: Scalars['String']['input'];
};


export type GQLQueryContractsArgs = {
  medicalInstitutionId: Scalars['ID']['input'];
};


export type GQLQueryContractsIncludingCanceledArgs = {
  medicalInstitutionId: Scalars['ID']['input'];
};


export type GQLQueryCsNotificationArgs = {
  id: Scalars['ID']['input'];
};


export type GQLQueryCsNotificationsArgs = {
  input?: InputMaybe<GQLCsNotificationsInput>;
};


export type GQLQueryDeliveryOrderArgs = {
  id: Scalars['ID']['input'];
};


export type GQLQueryDeliveryOrdersArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<GQLQueryOrderInput>;
};


export type GQLQueryDeliveryOrdersWithKeywordsArgs = {
  keywords: Array<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<GQLQueryOrderInput>;
};


export type GQLQueryEmailContactSummariesByMedicalInstitutionIdArgs = {
  id: Scalars['ID']['input'];
};


export type GQLQueryHaudyUserArgs = {
  id: Scalars['ID']['input'];
};


export type GQLQueryHaudyUsersArgs = {
  keyword?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<GQLQueryOrderInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type GQLQueryHtUserArgs = {
  id: Scalars['ID']['input'];
};


export type GQLQueryHtUsersArgs = {
  keyword?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<GQLQueryOrderInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type GQLQueryMedicalInstitutionDetailArgs = {
  medicalInstitutionId: Scalars['ID']['input'];
};


export type GQLQueryMedicalInstitutionMembersByMedicalInstitutionIdArgs = {
  medicalInstitutionId: Scalars['ID']['input'];
};


export type GQLQueryMedicalInstitutionsArgs = {
  keyword?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<GQLQueryOrderInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  withDeleted?: InputMaybe<Scalars['Boolean']['input']>;
};


export type GQLQueryNodeArgs = {
  id: Scalars['ID']['input'];
};


export type GQLQueryPdtArgs = {
  id: Scalars['ID']['input'];
};


export type GQLQueryPrescriptionByPrescriptionCodeArgs = {
  prescriptionCode: Scalars['String']['input'];
};


export type GQLQueryPrescriptionWithDeletedByPrescriptionCodeIdArgs = {
  prescriptionCodeId: Scalars['ID']['input'];
};


export type GQLQueryPreviewCsNotificationMarkdownArgs = {
  body: Scalars['String']['input'];
};


export type GQLQueryScUserArgs = {
  id: Scalars['ID']['input'];
};


export type GQLQueryScUsersArgs = {
  keyword?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<GQLQueryOrderInput>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};

export type GQLQueryOrderInput = {
  field: Scalars['String']['input'];
  value: GQLQueryOrderValue;
};

export const enum GQLQueryOrderValue {
  Asc = 'ASC',
  Desc = 'DESC'
};

export type GQLReceiptClass = {
  __typename?: 'ReceiptClass';
  code: GQLReceiptClassCode;
  name: Scalars['String']['output'];
};

export const enum GQLReceiptClassCode {
  Yt000 = 'YT000',
  Yt001 = 'YT001',
  Yt008 = 'YT008',
  Yt009 = 'YT009',
  Yt010 = 'YT010'
};

export type GQLReissueSecretCodePayload = {
  __typename?: 'ReissueSecretCodePayload';
  secretCode: Scalars['String']['output'];
};

export type GQLResendWelcomeMailFailure = {
  __typename?: 'ResendWelcomeMailFailure';
  message: Scalars['String']['output'];
};

export type GQLResendWelcomeMailInput = {
  contractId: Scalars['ID']['input'];
  recipientEmailAddress?: InputMaybe<Scalars['String']['input']>;
  reissueSecretCode?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GQLResendWelcomeMailPayload = GQLResendWelcomeMailFailure | GQLResendWelcomeMailSuccess;

export type GQLResendWelcomeMailSuccess = {
  __typename?: 'ResendWelcomeMailSuccess';
  contract: GQLContract;
  resendEmailAddress: Scalars['String']['output'];
};

export type GQLResendWelcomeMailV2Failure = {
  __typename?: 'ResendWelcomeMailV2Failure';
  message: Scalars['String']['output'];
};

export type GQLResendWelcomeMailV2Input = {
  contractId: Scalars['ID']['input'];
  memberId?: InputMaybe<Scalars['ID']['input']>;
  reissueIntegrationToken?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GQLResendWelcomeMailV2Payload = GQLResendWelcomeMailV2Failure | GQLResendWelcomeMailV2Success;

export type GQLResendWelcomeMailV2Success = {
  __typename?: 'ResendWelcomeMailV2Success';
  contract: GQLContract;
  resendEmailAddress: Scalars['String']['output'];
};

export type GQLScUser = {
  __typename?: 'SCUser';
  appName: Scalars['String']['output'];
  birthday?: Maybe<Scalars['Date']['output']>;
  coCheckerSerial?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  medicalInstitutionId: Scalars['String']['output'];
  medicalInstitutionName: Scalars['String']['output'];
  phoneNumber?: Maybe<Scalars['String']['output']>;
  prescribedAt?: Maybe<Scalars['Date']['output']>;
  prescription?: Maybe<GQLPrescription>;
  prescriptionCode: Scalars['String']['output'];
  registeredAt?: Maybe<Scalars['Date']['output']>;
};

export type GQLSendUpdatePasswordInput = {
  password: Scalars['String']['input'];
  recipientEmailAddress: Scalars['String']['input'];
};

export type GQLShippingDeadlineAdjustmentClass = {
  __typename?: 'ShippingDeadlineAdjustmentClass';
  code: GQLShippingDeadlineAdjustmentClassCode;
};

export const enum GQLShippingDeadlineAdjustmentClassCode {
  EndOfMonth = 'END_OF_MONTH',
  EndOfPreviousMonth = 'END_OF_PREVIOUS_MONTH',
  NoAdjustment = 'NO_ADJUSTMENT'
};

export type GQLShippingDeadlineManagementClass = {
  __typename?: 'ShippingDeadlineManagementClass';
  code: GQLShippingDeadlineManagementClassCode;
};

export const enum GQLShippingDeadlineManagementClassCode {
  Managed = 'MANAGED',
  NotManaged = 'NOT_MANAGED'
};

export type GQLStockManagementClass = {
  __typename?: 'StockManagementClass';
  code: GQLStockManagementClassCode;
};

export const enum GQLStockManagementClassCode {
  Managed = 'MANAGED',
  NotManaged = 'NOT_MANAGED'
};

export type GQLUpdateCsNotificationInput = {
  body: Scalars['String']['input'];
  endAt?: InputMaybe<Scalars['Date']['input']>;
  id: Scalars['ID']['input'];
  medicalInstitutionIds: Array<Scalars['String']['input']>;
  pdtCodes: Array<Scalars['String']['input']>;
  positions: Array<GQLMedicalInstitutionMemberPosition>;
  roles: Array<GQLMedicalInstitutionMemberRole>;
  startFrom: Scalars['Date']['input'];
  title: Scalars['String']['input'];
};

export type GQLUpdateHtUserEmailAddressInput = {
  email: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};

export type GQLUploadPdtDocumentInput = {
  enableFlag?: InputMaybe<Scalars['Boolean']['input']>;
  file: Scalars['Upload']['input'];
  fileName: Scalars['String']['input'];
  pdtId: Scalars['String']['input'];
  version?: InputMaybe<Scalars['Int']['input']>;
};

export type GQLVendor = {
  __typename?: 'Vendor';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type GQLVerifyCodeInput = {
  code: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  permanent?: InputMaybe<Scalars['Boolean']['input']>;
};



export type ResolverTypeWrapper<T> = Promise<T> | T;


export type ResolverWithResolve<TResult, TParent, TContext, TArgs> = {
  resolve: ResolverFn<TResult, TParent, TContext, TArgs>;
};
export type Resolver<TResult, TParent = Record<PropertyKey, never>, TContext = Record<PropertyKey, never>, TArgs = Record<PropertyKey, never>> = ResolverFn<TResult, TParent, TContext, TArgs> | ResolverWithResolve<TResult, TParent, TContext, TArgs>;

export type ResolverFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => Promise<TResult> | TResult;

export type SubscriptionSubscribeFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => AsyncIterable<TResult> | Promise<AsyncIterable<TResult>>;

export type SubscriptionResolveFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;

export interface SubscriptionSubscriberObject<TResult, TKey extends string, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<{ [key in TKey]: TResult }, TParent, TContext, TArgs>;
  resolve?: SubscriptionResolveFn<TResult, { [key in TKey]: TResult }, TContext, TArgs>;
}

export interface SubscriptionResolverObject<TResult, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<any, TParent, TContext, TArgs>;
  resolve: SubscriptionResolveFn<TResult, any, TContext, TArgs>;
}

export type SubscriptionObject<TResult, TKey extends string, TParent, TContext, TArgs> =
  | SubscriptionSubscriberObject<TResult, TKey, TParent, TContext, TArgs>
  | SubscriptionResolverObject<TResult, TParent, TContext, TArgs>;

export type SubscriptionResolver<TResult, TKey extends string, TParent = Record<PropertyKey, never>, TContext = Record<PropertyKey, never>, TArgs = Record<PropertyKey, never>> =
  | ((...args: any[]) => SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>)
  | SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>;

export type TypeResolveFn<TTypes, TParent = Record<PropertyKey, never>, TContext = Record<PropertyKey, never>> = (
  parent: TParent,
  context: TContext,
  info: GraphQLResolveInfo
) => Maybe<TTypes> | Promise<Maybe<TTypes>>;

export type IsTypeOfResolverFn<T = Record<PropertyKey, never>, TContext = Record<PropertyKey, never>> = (obj: T, context: TContext, info: GraphQLResolveInfo) => boolean | Promise<boolean>;

export type NextResolverFn<T> = () => Promise<T>;

export type DirectiveResolverFn<TResult = Record<PropertyKey, never>, TParent = Record<PropertyKey, never>, TContext = Record<PropertyKey, never>, TArgs = Record<PropertyKey, never>> = (
  next: NextResolverFn<TResult>,
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;



/** Mapping of union types */
export type GQLResolversUnionTypes<_RefType extends Record<string, unknown>> = {
  CancelMedicalInstitutionPayload:
    | ( GQLActiveContractExistsError )
    | ( Omit<GQLCancelMedicalInstitutionSuccess, 'medicalInstitution'> & { medicalInstitution: _RefType['MedicalInstitution'] } )
  ;
  CreateCsNotificationImageUploadUrlPayload:
    | ( GQLCsNotificationImageUploadUrl )
    | ( GQLCsNotificationImageUploadUrlError )
  ;
  DeleteCsNotificationPayload:
    | ( GQLDeleteCsNotificationError )
    | ( GQLDeleteCsNotificationSuccess )
  ;
  ForceCancelPrescriptionPayload:
    | ( GQLForceCancelPrescriptionError )
    | ( GQLPrescription )
  ;
  ResendWelcomeMailPayload:
    | ( GQLResendWelcomeMailFailure )
    | ( Omit<GQLResendWelcomeMailSuccess, 'contract'> & { contract: _RefType['Contract'] } )
  ;
  ResendWelcomeMailV2Payload:
    | ( GQLResendWelcomeMailV2Failure )
    | ( Omit<GQLResendWelcomeMailV2Success, 'contract'> & { contract: _RefType['Contract'] } )
  ;
};

/** Mapping of interface types */
export type GQLResolversInterfaceTypes<_RefType extends Record<string, unknown>> = {
  Error:
    | ( GQLCsNotificationImageUploadUrlError )
    | ( GQLDeleteCsNotificationError )
    | ( GQLForceCancelPrescriptionError )
  ;
  Node: never;
};

/** Mapping between all available schema types and the resolvers types */
export type GQLResolversTypes = {
  ActiveContractExistsError: ResolverTypeWrapper<GQLActiveContractExistsError>;
  BillingAccount: ResolverTypeWrapper<GQLBillingAccount>;
  Boolean: ResolverTypeWrapper<Scalars['Boolean']['output']>;
  CancelContractInput: GQLCancelContractInput;
  CancelContractPayload: ResolverTypeWrapper<CancelContractPayload>;
  CancelMedicalInstitutionInput: GQLCancelMedicalInstitutionInput;
  CancelMedicalInstitutionPayload: ResolverTypeWrapper<GQLResolversUnionTypes<GQLResolversTypes>['CancelMedicalInstitutionPayload']>;
  CancelMedicalInstitutionSuccess: ResolverTypeWrapper<Omit<GQLCancelMedicalInstitutionSuccess, 'medicalInstitution'> & { medicalInstitution: GQLResolversTypes['MedicalInstitution'] }>;
  ClientCertificate: ResolverTypeWrapper<Omit<GQLClientCertificate, 'medicalInstitution'> & { medicalInstitution: GQLResolversTypes['MedicalInstitution'] }>;
  Contract: ResolverTypeWrapper<Contract>;
  ContractManager: ResolverTypeWrapper<GQLContractManager>;
  ContractNotificationRecipient: ResolverTypeWrapper<GQLContractNotificationRecipient>;
  ContractResponsiblePerson: ResolverTypeWrapper<GQLContractResponsiblePerson>;
  CreateCsNotificationImageUploadUrlInput: GQLCreateCsNotificationImageUploadUrlInput;
  CreateCsNotificationImageUploadUrlPayload: ResolverTypeWrapper<GQLResolversUnionTypes<GQLResolversTypes>['CreateCsNotificationImageUploadUrlPayload']>;
  CreateCsNotificationInput: GQLCreateCsNotificationInput;
  CreateDeliveryOrderInput: GQLCreateDeliveryOrderInput;
  CreatePdtDocumentInput: GQLCreatePdtDocumentInput;
  CsNotification: ResolverTypeWrapper<AdminNotification>;
  CsNotificationImageUploadUrl: ResolverTypeWrapper<GQLCsNotificationImageUploadUrl>;
  CsNotificationImageUploadUrlError: ResolverTypeWrapper<GQLCsNotificationImageUploadUrlError>;
  CsNotificationPayload: ResolverTypeWrapper<GQLCsNotificationPayload>;
  CsNotificationsInput: GQLCsNotificationsInput;
  CsNotificationsPayload: ResolverTypeWrapper<AdminNotificationsResult>;
  Date: ResolverTypeWrapper<Scalars['Date']['output']>;
  DeleteCsNotificationError: ResolverTypeWrapper<GQLDeleteCsNotificationError>;
  DeleteCsNotificationPayload: ResolverTypeWrapper<GQLResolversUnionTypes<GQLResolversTypes>['DeleteCsNotificationPayload']>;
  DeleteCsNotificationSuccess: ResolverTypeWrapper<GQLDeleteCsNotificationSuccess>;
  DeliveryHistory: ResolverTypeWrapper<GQLDeliveryHistory>;
  DeliveryOrder: ResolverTypeWrapper<GQLDeliveryOrder>;
  DeliveryOrderField: ResolverTypeWrapper<GQLDeliveryOrderField>;
  DeliveryProducts: ResolverTypeWrapper<GQLDeliveryProducts>;
  DeliveryProductsInput: GQLDeliveryProductsInput;
  DeliveryStatus: ResolverTypeWrapper<GQLDeliveryStatus>;
  DeliveryStatusCode: GQLDeliveryStatusCode;
  DeliveryTime: ResolverTypeWrapper<GQLDeliveryTime>;
  DeliveryTimeCode: GQLDeliveryTimeCode;
  EmailContact: ResolverTypeWrapper<GQLEmailContact>;
  EmailContactPdt: ResolverTypeWrapper<GQLEmailContactPdt>;
  EmailContactSummary: ResolverTypeWrapper<GQLEmailContactSummary>;
  Error: ResolverTypeWrapper<GQLResolversInterfaceTypes<GQLResolversTypes>['Error']>;
  Float: ResolverTypeWrapper<Scalars['Float']['output']>;
  ForceCancelPrescriptionError: ResolverTypeWrapper<GQLForceCancelPrescriptionError>;
  ForceCancelPrescriptionInput: GQLForceCancelPrescriptionInput;
  ForceCancelPrescriptionPayload: ResolverTypeWrapper<GQLResolversUnionTypes<GQLResolversTypes>['ForceCancelPrescriptionPayload']>;
  HTUser: ResolverTypeWrapper<GQLHtUser>;
  HTVerifyCode: ResolverTypeWrapper<GQLHtVerifyCode>;
  HaudyUser: ResolverTypeWrapper<GQLHaudyUser>;
  ID: ResolverTypeWrapper<Scalars['ID']['output']>;
  Int: ResolverTypeWrapper<Scalars['Int']['output']>;
  Json: ResolverTypeWrapper<Scalars['Json']['output']>;
  ListHTUser: ResolverTypeWrapper<GQLListHtUser>;
  ListHaudyUser: ResolverTypeWrapper<GQLListHaudyUser>;
  ListSCUser: ResolverTypeWrapper<GQLListScUser>;
  MedicalInstitution: ResolverTypeWrapper<MedicalInstitution>;
  MedicalInstitutionDetail: ResolverTypeWrapper<MedicalInstitutionDetail>;
  MedicalInstitutionMember: ResolverTypeWrapper<MedicalInstitutionMember>;
  MedicalInstitutionMemberPosition: GQLMedicalInstitutionMemberPosition;
  MedicalInstitutionMemberRole: GQLMedicalInstitutionMemberRole;
  MedicalInstitutionMemberStatus: GQLMedicalInstitutionMemberStatus;
  MemberContract: ResolverTypeWrapper<GQLMemberContract>;
  Mutation: ResolverTypeWrapper<Record<PropertyKey, never>>;
  Node: ResolverTypeWrapper<GQLResolversInterfaceTypes<GQLResolversTypes>['Node']>;
  NoopInput: GQLNoopInput;
  NoopPayload: ResolverTypeWrapper<GQLNoopPayload>;
  NotificationSource: GQLNotificationSource;
  OrderClass: ResolverTypeWrapper<GQLOrderClass>;
  OrderClassCode: GQLOrderClassCode;
  Pdt: ResolverTypeWrapper<GQLPdt>;
  PdtDocument: ResolverTypeWrapper<GQLPdtDocument>;
  Prescription: ResolverTypeWrapper<GQLPrescription>;
  PrescriptionByPrescriptionCodePayload: ResolverTypeWrapper<GQLPrescriptionByPrescriptionCodePayload>;
  PrescriptionCodeStatusLabel: GQLPrescriptionCodeStatusLabel;
  PrescriptionCodeStatusLabelForCsSystem: GQLPrescriptionCodeStatusLabelForCsSystem;
  PrescriptionCureAppPdtCode: ResolverTypeWrapper<GQLPrescriptionCureAppPdtCode>;
  PrescriptionWithDeletedByPrescriptionCodeIdPayload: ResolverTypeWrapper<Omit<GQLPrescriptionWithDeletedByPrescriptionCodeIdPayload, 'contract' | 'medicalInstitutionMember'> & { contract: GQLResolversTypes['Contract'], medicalInstitutionMember: GQLResolversTypes['MedicalInstitutionMember'] }>;
  Product: ResolverTypeWrapper<GQLProduct>;
  ProductClass: ResolverTypeWrapper<GQLProductClass>;
  ProductClassCode: GQLProductClassCode;
  ProductSet: ResolverTypeWrapper<GQLProductSet>;
  Query: ResolverTypeWrapper<Record<PropertyKey, never>>;
  QueryOrderInput: GQLQueryOrderInput;
  QueryOrderValue: GQLQueryOrderValue;
  ReceiptClass: ResolverTypeWrapper<GQLReceiptClass>;
  ReceiptClassCode: GQLReceiptClassCode;
  ReissueSecretCodePayload: ResolverTypeWrapper<GQLReissueSecretCodePayload>;
  ResendWelcomeMailFailure: ResolverTypeWrapper<GQLResendWelcomeMailFailure>;
  ResendWelcomeMailInput: GQLResendWelcomeMailInput;
  ResendWelcomeMailPayload: ResolverTypeWrapper<GQLResolversUnionTypes<GQLResolversTypes>['ResendWelcomeMailPayload']>;
  ResendWelcomeMailSuccess: ResolverTypeWrapper<Omit<GQLResendWelcomeMailSuccess, 'contract'> & { contract: GQLResolversTypes['Contract'] }>;
  ResendWelcomeMailV2Failure: ResolverTypeWrapper<GQLResendWelcomeMailV2Failure>;
  ResendWelcomeMailV2Input: GQLResendWelcomeMailV2Input;
  ResendWelcomeMailV2Payload: ResolverTypeWrapper<GQLResolversUnionTypes<GQLResolversTypes>['ResendWelcomeMailV2Payload']>;
  ResendWelcomeMailV2Success: ResolverTypeWrapper<Omit<GQLResendWelcomeMailV2Success, 'contract'> & { contract: GQLResolversTypes['Contract'] }>;
  SCUser: ResolverTypeWrapper<GQLScUser>;
  SendUpdatePasswordInput: GQLSendUpdatePasswordInput;
  ShippingDeadlineAdjustmentClass: ResolverTypeWrapper<GQLShippingDeadlineAdjustmentClass>;
  ShippingDeadlineAdjustmentClassCode: GQLShippingDeadlineAdjustmentClassCode;
  ShippingDeadlineManagementClass: ResolverTypeWrapper<GQLShippingDeadlineManagementClass>;
  ShippingDeadlineManagementClassCode: GQLShippingDeadlineManagementClassCode;
  StockManagementClass: ResolverTypeWrapper<GQLStockManagementClass>;
  StockManagementClassCode: GQLStockManagementClassCode;
  String: ResolverTypeWrapper<Scalars['String']['output']>;
  UpdateCsNotificationInput: GQLUpdateCsNotificationInput;
  UpdateHtUserEmailAddressInput: GQLUpdateHtUserEmailAddressInput;
  Upload: ResolverTypeWrapper<Scalars['Upload']['output']>;
  UploadPdtDocumentInput: GQLUploadPdtDocumentInput;
  Vendor: ResolverTypeWrapper<GQLVendor>;
  VerifyCodeInput: GQLVerifyCodeInput;
};

/** Mapping between all available schema types and the resolvers parents */
export type GQLResolversParentTypes = {
  ActiveContractExistsError: GQLActiveContractExistsError;
  BillingAccount: GQLBillingAccount;
  Boolean: Scalars['Boolean']['output'];
  CancelContractInput: GQLCancelContractInput;
  CancelContractPayload: CancelContractPayload;
  CancelMedicalInstitutionInput: GQLCancelMedicalInstitutionInput;
  CancelMedicalInstitutionPayload: GQLResolversUnionTypes<GQLResolversParentTypes>['CancelMedicalInstitutionPayload'];
  CancelMedicalInstitutionSuccess: Omit<GQLCancelMedicalInstitutionSuccess, 'medicalInstitution'> & { medicalInstitution: GQLResolversParentTypes['MedicalInstitution'] };
  ClientCertificate: Omit<GQLClientCertificate, 'medicalInstitution'> & { medicalInstitution: GQLResolversParentTypes['MedicalInstitution'] };
  Contract: Contract;
  ContractManager: GQLContractManager;
  ContractNotificationRecipient: GQLContractNotificationRecipient;
  ContractResponsiblePerson: GQLContractResponsiblePerson;
  CreateCsNotificationImageUploadUrlInput: GQLCreateCsNotificationImageUploadUrlInput;
  CreateCsNotificationImageUploadUrlPayload: GQLResolversUnionTypes<GQLResolversParentTypes>['CreateCsNotificationImageUploadUrlPayload'];
  CreateCsNotificationInput: GQLCreateCsNotificationInput;
  CreateDeliveryOrderInput: GQLCreateDeliveryOrderInput;
  CreatePdtDocumentInput: GQLCreatePdtDocumentInput;
  CsNotification: AdminNotification;
  CsNotificationImageUploadUrl: GQLCsNotificationImageUploadUrl;
  CsNotificationImageUploadUrlError: GQLCsNotificationImageUploadUrlError;
  CsNotificationPayload: GQLCsNotificationPayload;
  CsNotificationsInput: GQLCsNotificationsInput;
  CsNotificationsPayload: AdminNotificationsResult;
  Date: Scalars['Date']['output'];
  DeleteCsNotificationError: GQLDeleteCsNotificationError;
  DeleteCsNotificationPayload: GQLResolversUnionTypes<GQLResolversParentTypes>['DeleteCsNotificationPayload'];
  DeleteCsNotificationSuccess: GQLDeleteCsNotificationSuccess;
  DeliveryHistory: GQLDeliveryHistory;
  DeliveryOrder: GQLDeliveryOrder;
  DeliveryOrderField: GQLDeliveryOrderField;
  DeliveryProducts: GQLDeliveryProducts;
  DeliveryProductsInput: GQLDeliveryProductsInput;
  DeliveryStatus: GQLDeliveryStatus;
  DeliveryTime: GQLDeliveryTime;
  EmailContact: GQLEmailContact;
  EmailContactPdt: GQLEmailContactPdt;
  EmailContactSummary: GQLEmailContactSummary;
  Error: GQLResolversInterfaceTypes<GQLResolversParentTypes>['Error'];
  Float: Scalars['Float']['output'];
  ForceCancelPrescriptionError: GQLForceCancelPrescriptionError;
  ForceCancelPrescriptionInput: GQLForceCancelPrescriptionInput;
  ForceCancelPrescriptionPayload: GQLResolversUnionTypes<GQLResolversParentTypes>['ForceCancelPrescriptionPayload'];
  HTUser: GQLHtUser;
  HTVerifyCode: GQLHtVerifyCode;
  HaudyUser: GQLHaudyUser;
  ID: Scalars['ID']['output'];
  Int: Scalars['Int']['output'];
  Json: Scalars['Json']['output'];
  ListHTUser: GQLListHtUser;
  ListHaudyUser: GQLListHaudyUser;
  ListSCUser: GQLListScUser;
  MedicalInstitution: MedicalInstitution;
  MedicalInstitutionDetail: MedicalInstitutionDetail;
  MedicalInstitutionMember: MedicalInstitutionMember;
  MemberContract: GQLMemberContract;
  Mutation: Record<PropertyKey, never>;
  Node: GQLResolversInterfaceTypes<GQLResolversParentTypes>['Node'];
  NoopInput: GQLNoopInput;
  NoopPayload: GQLNoopPayload;
  OrderClass: GQLOrderClass;
  Pdt: GQLPdt;
  PdtDocument: GQLPdtDocument;
  Prescription: GQLPrescription;
  PrescriptionByPrescriptionCodePayload: GQLPrescriptionByPrescriptionCodePayload;
  PrescriptionCureAppPdtCode: GQLPrescriptionCureAppPdtCode;
  PrescriptionWithDeletedByPrescriptionCodeIdPayload: Omit<GQLPrescriptionWithDeletedByPrescriptionCodeIdPayload, 'contract' | 'medicalInstitutionMember'> & { contract: GQLResolversParentTypes['Contract'], medicalInstitutionMember: GQLResolversParentTypes['MedicalInstitutionMember'] };
  Product: GQLProduct;
  ProductClass: GQLProductClass;
  ProductSet: GQLProductSet;
  Query: Record<PropertyKey, never>;
  QueryOrderInput: GQLQueryOrderInput;
  ReceiptClass: GQLReceiptClass;
  ReissueSecretCodePayload: GQLReissueSecretCodePayload;
  ResendWelcomeMailFailure: GQLResendWelcomeMailFailure;
  ResendWelcomeMailInput: GQLResendWelcomeMailInput;
  ResendWelcomeMailPayload: GQLResolversUnionTypes<GQLResolversParentTypes>['ResendWelcomeMailPayload'];
  ResendWelcomeMailSuccess: Omit<GQLResendWelcomeMailSuccess, 'contract'> & { contract: GQLResolversParentTypes['Contract'] };
  ResendWelcomeMailV2Failure: GQLResendWelcomeMailV2Failure;
  ResendWelcomeMailV2Input: GQLResendWelcomeMailV2Input;
  ResendWelcomeMailV2Payload: GQLResolversUnionTypes<GQLResolversParentTypes>['ResendWelcomeMailV2Payload'];
  ResendWelcomeMailV2Success: Omit<GQLResendWelcomeMailV2Success, 'contract'> & { contract: GQLResolversParentTypes['Contract'] };
  SCUser: GQLScUser;
  SendUpdatePasswordInput: GQLSendUpdatePasswordInput;
  ShippingDeadlineAdjustmentClass: GQLShippingDeadlineAdjustmentClass;
  ShippingDeadlineManagementClass: GQLShippingDeadlineManagementClass;
  StockManagementClass: GQLStockManagementClass;
  String: Scalars['String']['output'];
  UpdateCsNotificationInput: GQLUpdateCsNotificationInput;
  UpdateHtUserEmailAddressInput: GQLUpdateHtUserEmailAddressInput;
  Upload: Scalars['Upload']['output'];
  UploadPdtDocumentInput: GQLUploadPdtDocumentInput;
  Vendor: GQLVendor;
  VerifyCodeInput: GQLVerifyCodeInput;
};

export type GQLActiveContractExistsErrorResolvers<ContextType = any, ParentType extends GQLResolversParentTypes['ActiveContractExistsError'] = GQLResolversParentTypes['ActiveContractExistsError']> = {
  activeContractCount?: Resolver<GQLResolversTypes['Int'], ParentType, ContextType>;
  code?: Resolver<GQLResolversTypes['String'], ParentType, ContextType>;
  medicalInstitutionId?: Resolver<GQLResolversTypes['String'], ParentType, ContextType>;
  message?: Resolver<GQLResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQLBillingAccountResolvers<ContextType = any, ParentType extends GQLResolversParentTypes['BillingAccount'] = GQLResolversParentTypes['BillingAccount']> = {
  billingAccountId?: Resolver<GQLResolversTypes['String'], ParentType, ContextType>;
  contactEmailAddress?: Resolver<GQLResolversTypes['String'], ParentType, ContextType>;
  contactName?: Resolver<GQLResolversTypes['String'], ParentType, ContextType>;
  department?: Resolver<Maybe<GQLResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<GQLResolversTypes['String'], ParentType, ContextType>;
  sendEmail?: Resolver<GQLResolversTypes['Boolean'], ParentType, ContextType>;
  sendMail?: Resolver<GQLResolversTypes['Boolean'], ParentType, ContextType>;
};

export type GQLCancelContractPayloadResolvers<ContextType = any, ParentType extends GQLResolversParentTypes['CancelContractPayload'] = GQLResolversParentTypes['CancelContractPayload']> = {
  contract?: Resolver<GQLResolversTypes['Contract'], ParentType, ContextType>;
};

export type GQLCancelMedicalInstitutionPayloadResolvers<ContextType = any, ParentType extends GQLResolversParentTypes['CancelMedicalInstitutionPayload'] = GQLResolversParentTypes['CancelMedicalInstitutionPayload']> = {
  __resolveType: TypeResolveFn<'ActiveContractExistsError' | 'CancelMedicalInstitutionSuccess', ParentType, ContextType>;
};

export type GQLCancelMedicalInstitutionSuccessResolvers<ContextType = any, ParentType extends GQLResolversParentTypes['CancelMedicalInstitutionSuccess'] = GQLResolversParentTypes['CancelMedicalInstitutionSuccess']> = {
  medicalInstitution?: Resolver<GQLResolversTypes['MedicalInstitution'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQLClientCertificateResolvers<ContextType = any, ParentType extends GQLResolversParentTypes['ClientCertificate'] = GQLResolversParentTypes['ClientCertificate']> = {
  createdAt?: Resolver<GQLResolversTypes['Date'], ParentType, ContextType>;
  domain?: Resolver<GQLResolversTypes['String'], ParentType, ContextType>;
  downloadUrl?: Resolver<Maybe<GQLResolversTypes['String']>, ParentType, ContextType>;
  expiresAt?: Resolver<Maybe<GQLResolversTypes['Date']>, ParentType, ContextType>;
  id?: Resolver<GQLResolversTypes['ID'], ParentType, ContextType>;
  isUsed?: Resolver<GQLResolversTypes['Boolean'], ParentType, ContextType>;
  medicalInstitution?: Resolver<GQLResolversTypes['MedicalInstitution'], ParentType, ContextType>;
  name?: Resolver<GQLResolversTypes['String'], ParentType, ContextType>;
  password?: Resolver<Maybe<GQLResolversTypes['String']>, ParentType, ContextType>;
  serialNumber?: Resolver<Maybe<GQLResolversTypes['String']>, ParentType, ContextType>;
  updatedAt?: Resolver<GQLResolversTypes['Date'], ParentType, ContextType>;
};

export type GQLContractResolvers<ContextType = any, ParentType extends GQLResolversParentTypes['Contract'] = GQLResolversParentTypes['Contract']> = {
  createdAt?: Resolver<GQLResolversTypes['Date'], ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<GQLResolversTypes['Date']>, ParentType, ContextType>;
  id?: Resolver<GQLResolversTypes['ID'], ParentType, ContextType>;
  initial?: Resolver<GQLResolversTypes['Boolean'], ParentType, ContextType>;
  manager?: Resolver<Maybe<GQLResolversTypes['ContractManager']>, ParentType, ContextType>;
  notificationRecipients?: Resolver<Maybe<Array<GQLResolversTypes['ContractNotificationRecipient']>>, ParentType, ContextType>;
  pdt?: Resolver<GQLResolversTypes['Pdt'], ParentType, ContextType>;
  responsiblePerson?: Resolver<Maybe<GQLResolversTypes['ContractResponsiblePerson']>, ParentType, ContextType>;
};

export type GQLContractManagerResolvers<ContextType = any, ParentType extends GQLResolversParentTypes['ContractManager'] = GQLResolversParentTypes['ContractManager']> = {
  department?: Resolver<Maybe<GQLResolversTypes['String']>, ParentType, ContextType>;
  emailAddress?: Resolver<Maybe<GQLResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<GQLResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<Maybe<GQLResolversTypes['String']>, ParentType, ContextType>;
  welcomeMailSentAt?: Resolver<Maybe<GQLResolversTypes['Date']>, ParentType, ContextType>;
};

export type GQLContractNotificationRecipientResolvers<ContextType = any, ParentType extends GQLResolversParentTypes['ContractNotificationRecipient'] = GQLResolversParentTypes['ContractNotificationRecipient']> = {
  emailContact?: Resolver<GQLResolversTypes['EmailContact'], ParentType, ContextType>;
  id?: Resolver<GQLResolversTypes['ID'], ParentType, ContextType>;
};

export type GQLContractResponsiblePersonResolvers<ContextType = any, ParentType extends GQLResolversParentTypes['ContractResponsiblePerson'] = GQLResolversParentTypes['ContractResponsiblePerson']> = {
  emailContact?: Resolver<GQLResolversTypes['EmailContact'], ParentType, ContextType>;
  id?: Resolver<GQLResolversTypes['ID'], ParentType, ContextType>;
  welcomeMailSentAt?: Resolver<Maybe<GQLResolversTypes['Date']>, ParentType, ContextType>;
};

export type GQLCreateCsNotificationImageUploadUrlPayloadResolvers<ContextType = any, ParentType extends GQLResolversParentTypes['CreateCsNotificationImageUploadUrlPayload'] = GQLResolversParentTypes['CreateCsNotificationImageUploadUrlPayload']> = {
  __resolveType: TypeResolveFn<'CsNotificationImageUploadUrl' | 'CsNotificationImageUploadUrlError', ParentType, ContextType>;
};

export type GQLCsNotificationResolvers<ContextType = any, ParentType extends GQLResolversParentTypes['CsNotification'] = GQLResolversParentTypes['CsNotification']> = {
  body?: Resolver<GQLResolversTypes['String'], ParentType, ContextType>;
  createdAt?: Resolver<GQLResolversTypes['Date'], ParentType, ContextType>;
  endAt?: Resolver<Maybe<GQLResolversTypes['Date']>, ParentType, ContextType>;
  id?: Resolver<GQLResolversTypes['ID'], ParentType, ContextType>;
  isDeletable?: Resolver<GQLResolversTypes['Boolean'], ParentType, ContextType>;
  isEditable?: Resolver<GQLResolversTypes['Boolean'], ParentType, ContextType>;
  medicalInstitutionIds?: Resolver<Array<GQLResolversTypes['String']>, ParentType, ContextType>;
  pdtCodes?: Resolver<Array<GQLResolversTypes['String']>, ParentType, ContextType>;
  positions?: Resolver<Array<GQLResolversTypes['MedicalInstitutionMemberPosition']>, ParentType, ContextType>;
  roles?: Resolver<Array<GQLResolversTypes['MedicalInstitutionMemberRole']>, ParentType, ContextType>;
  source?: Resolver<GQLResolversTypes['NotificationSource'], ParentType, ContextType>;
  startFrom?: Resolver<GQLResolversTypes['Date'], ParentType, ContextType>;
  termsVersionId?: Resolver<Maybe<GQLResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<GQLResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<GQLResolversTypes['Date'], ParentType, ContextType>;
};

export type GQLCsNotificationImageUploadUrlResolvers<ContextType = any, ParentType extends GQLResolversParentTypes['CsNotificationImageUploadUrl'] = GQLResolversParentTypes['CsNotificationImageUploadUrl']> = {
  fields?: Resolver<GQLResolversTypes['String'], ParentType, ContextType>;
  key?: Resolver<GQLResolversTypes['String'], ParentType, ContextType>;
  url?: Resolver<GQLResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQLCsNotificationImageUploadUrlErrorResolvers<ContextType = any, ParentType extends GQLResolversParentTypes['CsNotificationImageUploadUrlError'] = GQLResolversParentTypes['CsNotificationImageUploadUrlError']> = {
  code?: Resolver<GQLResolversTypes['String'], ParentType, ContextType>;
  message?: Resolver<GQLResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQLCsNotificationPayloadResolvers<ContextType = any, ParentType extends GQLResolversParentTypes['CsNotificationPayload'] = GQLResolversParentTypes['CsNotificationPayload']> = {
  id?: Resolver<GQLResolversTypes['ID'], ParentType, ContextType>;
  title?: Resolver<GQLResolversTypes['String'], ParentType, ContextType>;
};

export type GQLCsNotificationsPayloadResolvers<ContextType = any, ParentType extends GQLResolversParentTypes['CsNotificationsPayload'] = GQLResolversParentTypes['CsNotificationsPayload']> = {
  notifications?: Resolver<Array<GQLResolversTypes['CsNotification']>, ParentType, ContextType>;
  totalCount?: Resolver<GQLResolversTypes['Int'], ParentType, ContextType>;
};

export interface GQLDateScalarConfig extends GraphQLScalarTypeConfig<GQLResolversTypes['Date'], any> {
  name: 'Date';
}

export type GQLDeleteCsNotificationErrorResolvers<ContextType = any, ParentType extends GQLResolversParentTypes['DeleteCsNotificationError'] = GQLResolversParentTypes['DeleteCsNotificationError']> = {
  code?: Resolver<GQLResolversTypes['String'], ParentType, ContextType>;
  message?: Resolver<GQLResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQLDeleteCsNotificationPayloadResolvers<ContextType = any, ParentType extends GQLResolversParentTypes['DeleteCsNotificationPayload'] = GQLResolversParentTypes['DeleteCsNotificationPayload']> = {
  __resolveType: TypeResolveFn<'DeleteCsNotificationError' | 'DeleteCsNotificationSuccess', ParentType, ContextType>;
};

export type GQLDeleteCsNotificationSuccessResolvers<ContextType = any, ParentType extends GQLResolversParentTypes['DeleteCsNotificationSuccess'] = GQLResolversParentTypes['DeleteCsNotificationSuccess']> = {
  id?: Resolver<GQLResolversTypes['ID'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQLDeliveryHistoryResolvers<ContextType = any, ParentType extends GQLResolversParentTypes['DeliveryHistory'] = GQLResolversParentTypes['DeliveryHistory']> = {
  createdAt?: Resolver<GQLResolversTypes['Date'], ParentType, ContextType>;
  deliveryOrder?: Resolver<GQLResolversTypes['DeliveryOrder'], ParentType, ContextType>;
  id?: Resolver<GQLResolversTypes['ID'], ParentType, ContextType>;
  outputAt?: Resolver<Maybe<GQLResolversTypes['Date']>, ParentType, ContextType>;
  product?: Resolver<GQLResolversTypes['Product'], ParentType, ContextType>;
  serialNumber?: Resolver<Maybe<GQLResolversTypes['String']>, ParentType, ContextType>;
  shipConfirmedAt?: Resolver<Maybe<GQLResolversTypes['String']>, ParentType, ContextType>;
  slipNumber?: Resolver<Maybe<GQLResolversTypes['String']>, ParentType, ContextType>;
};

export type GQLDeliveryOrderResolvers<ContextType = any, ParentType extends GQLResolversParentTypes['DeliveryOrder'] = GQLResolversParentTypes['DeliveryOrder']> = {
  address?: Resolver<GQLResolversTypes['String'], ParentType, ContextType>;
  clientCertificatePassword?: Resolver<Maybe<GQLResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<GQLResolversTypes['Date'], ParentType, ContextType>;
  deliveryDate?: Resolver<Maybe<GQLResolversTypes['String']>, ParentType, ContextType>;
  deliveryHistory?: Resolver<Array<GQLResolversTypes['DeliveryHistory']>, ParentType, ContextType>;
  deliveryProducts?: Resolver<Array<GQLResolversTypes['DeliveryProducts']>, ParentType, ContextType>;
  deliveryStatus?: Resolver<GQLResolversTypes['DeliveryStatus'], ParentType, ContextType>;
  deliveryTime?: Resolver<GQLResolversTypes['DeliveryTime'], ParentType, ContextType>;
  id?: Resolver<GQLResolversTypes['ID'], ParentType, ContextType>;
  isDummy?: Resolver<GQLResolversTypes['Boolean'], ParentType, ContextType>;
  name?: Resolver<GQLResolversTypes['String'], ParentType, ContextType>;
  orderClass?: Resolver<GQLResolversTypes['OrderClass'], ParentType, ContextType>;
  phoneNumber?: Resolver<GQLResolversTypes['String'], ParentType, ContextType>;
  postalCode?: Resolver<GQLResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<GQLResolversTypes['Date'], ParentType, ContextType>;
};

export type GQLDeliveryOrderFieldResolvers<ContextType = any, ParentType extends GQLResolversParentTypes['DeliveryOrderField'] = GQLResolversParentTypes['DeliveryOrderField']> = {
  address?: Resolver<GQLResolversTypes['String'], ParentType, ContextType>;
  deliveryDate?: Resolver<Maybe<GQLResolversTypes['Date']>, ParentType, ContextType>;
  deliveryHistory?: Resolver<Array<GQLResolversTypes['DeliveryHistory']>, ParentType, ContextType>;
  deliveryProducts?: Resolver<Array<GQLResolversTypes['DeliveryProducts']>, ParentType, ContextType>;
  deliveryStatus?: Resolver<GQLResolversTypes['DeliveryStatus'], ParentType, ContextType>;
  deliveryTime?: Resolver<GQLResolversTypes['DeliveryTime'], ParentType, ContextType>;
  id?: Resolver<GQLResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<GQLResolversTypes['String'], ParentType, ContextType>;
  phoneNumber?: Resolver<GQLResolversTypes['String'], ParentType, ContextType>;
  postalCode?: Resolver<GQLResolversTypes['String'], ParentType, ContextType>;
};

export type GQLDeliveryProductsResolvers<ContextType = any, ParentType extends GQLResolversParentTypes['DeliveryProducts'] = GQLResolversParentTypes['DeliveryProducts']> = {
  collective?: Resolver<GQLResolversTypes['Boolean'], ParentType, ContextType>;
  product?: Resolver<GQLResolversTypes['Product'], ParentType, ContextType>;
  quantity?: Resolver<GQLResolversTypes['Int'], ParentType, ContextType>;
  returnQuantity?: Resolver<GQLResolversTypes['Int'], ParentType, ContextType>;
};

export type GQLDeliveryStatusResolvers<ContextType = any, ParentType extends GQLResolversParentTypes['DeliveryStatus'] = GQLResolversParentTypes['DeliveryStatus']> = {
  code?: Resolver<GQLResolversTypes['DeliveryStatusCode'], ParentType, ContextType>;
};

export type GQLDeliveryTimeResolvers<ContextType = any, ParentType extends GQLResolversParentTypes['DeliveryTime'] = GQLResolversParentTypes['DeliveryTime']> = {
  code?: Resolver<GQLResolversTypes['DeliveryTimeCode'], ParentType, ContextType>;
  section?: Resolver<GQLResolversTypes['String'], ParentType, ContextType>;
};

export type GQLEmailContactResolvers<ContextType = any, ParentType extends GQLResolversParentTypes['EmailContact'] = GQLResolversParentTypes['EmailContact']> = {
  department?: Resolver<Maybe<GQLResolversTypes['String']>, ParentType, ContextType>;
  emailAddress?: Resolver<GQLResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<GQLResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<GQLResolversTypes['String'], ParentType, ContextType>;
};

export type GQLEmailContactPdtResolvers<ContextType = any, ParentType extends GQLResolversParentTypes['EmailContactPdt'] = GQLResolversParentTypes['EmailContactPdt']> = {
  code?: Resolver<GQLResolversTypes['String'], ParentType, ContextType>;
  iconPath?: Resolver<GQLResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<GQLResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<GQLResolversTypes['String'], ParentType, ContextType>;
};

export type GQLEmailContactSummaryResolvers<ContextType = any, ParentType extends GQLResolversParentTypes['EmailContactSummary'] = GQLResolversParentTypes['EmailContactSummary']> = {
  department?: Resolver<Maybe<GQLResolversTypes['String']>, ParentType, ContextType>;
  emailAddress?: Resolver<GQLResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<GQLResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<GQLResolversTypes['String'], ParentType, ContextType>;
  notificationRecipients?: Resolver<Maybe<Array<Maybe<GQLResolversTypes['EmailContactPdt']>>>, ParentType, ContextType>;
  responsiblePersons?: Resolver<Maybe<Array<Maybe<GQLResolversTypes['EmailContactPdt']>>>, ParentType, ContextType>;
};

export type GQLErrorResolvers<ContextType = any, ParentType extends GQLResolversParentTypes['Error'] = GQLResolversParentTypes['Error']> = {
  __resolveType: TypeResolveFn<'CsNotificationImageUploadUrlError' | 'DeleteCsNotificationError' | 'ForceCancelPrescriptionError', ParentType, ContextType>;
};

export type GQLForceCancelPrescriptionErrorResolvers<ContextType = any, ParentType extends GQLResolversParentTypes['ForceCancelPrescriptionError'] = GQLResolversParentTypes['ForceCancelPrescriptionError']> = {
  code?: Resolver<GQLResolversTypes['String'], ParentType, ContextType>;
  message?: Resolver<GQLResolversTypes['String'], ParentType, ContextType>;
  prescriptionCode?: Resolver<GQLResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQLForceCancelPrescriptionPayloadResolvers<ContextType = any, ParentType extends GQLResolversParentTypes['ForceCancelPrescriptionPayload'] = GQLResolversParentTypes['ForceCancelPrescriptionPayload']> = {
  __resolveType: TypeResolveFn<'ForceCancelPrescriptionError' | 'Prescription', ParentType, ContextType>;
};

export type GQLHtUserResolvers<ContextType = any, ParentType extends GQLResolversParentTypes['HTUser'] = GQLResolversParentTypes['HTUser']> = {
  appName?: Resolver<GQLResolversTypes['String'], ParentType, ContextType>;
  birthday?: Resolver<Maybe<GQLResolversTypes['Date']>, ParentType, ContextType>;
  bloodPressureMeasurementRate?: Resolver<Maybe<GQLResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<GQLResolversTypes['Date']>, ParentType, ContextType>;
  email?: Resolver<Maybe<GQLResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<GQLResolversTypes['ID'], ParentType, ContextType>;
  maskedDetail?: Resolver<Maybe<GQLResolversTypes['Json']>, ParentType, ContextType>;
  medicalInstitutionId?: Resolver<Maybe<GQLResolversTypes['String']>, ParentType, ContextType>;
  medicalInstitutionName?: Resolver<Maybe<GQLResolversTypes['String']>, ParentType, ContextType>;
  nickname?: Resolver<Maybe<GQLResolversTypes['String']>, ParentType, ContextType>;
  pdtCode?: Resolver<Maybe<GQLResolversTypes['String']>, ParentType, ContextType>;
  pdtId?: Resolver<Maybe<GQLResolversTypes['String']>, ParentType, ContextType>;
  prescribedAt?: Resolver<Maybe<GQLResolversTypes['Date']>, ParentType, ContextType>;
  prescription?: Resolver<Maybe<GQLResolversTypes['Prescription']>, ParentType, ContextType>;
  prescriptionCode?: Resolver<GQLResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<GQLResolversTypes['String'], ParentType, ContextType>;
};

export type GQLHtVerifyCodeResolvers<ContextType = any, ParentType extends GQLResolversParentTypes['HTVerifyCode'] = GQLResolversParentTypes['HTVerifyCode']> = {
  code?: Resolver<GQLResolversTypes['String'], ParentType, ContextType>;
  permanent?: Resolver<GQLResolversTypes['Boolean'], ParentType, ContextType>;
};

export type GQLHaudyUserResolvers<ContextType = any, ParentType extends GQLResolversParentTypes['HaudyUser'] = GQLResolversParentTypes['HaudyUser']> = {
  activatedAt?: Resolver<Maybe<GQLResolversTypes['Date']>, ParentType, ContextType>;
  appName?: Resolver<GQLResolversTypes['String'], ParentType, ContextType>;
  birthMonth?: Resolver<Maybe<GQLResolversTypes['Date']>, ParentType, ContextType>;
  drinkingRecordRate?: Resolver<Maybe<GQLResolversTypes['Float']>, ParentType, ContextType>;
  firstConsultationAt?: Resolver<Maybe<GQLResolversTypes['Date']>, ParentType, ContextType>;
  id?: Resolver<GQLResolversTypes['ID'], ParentType, ContextType>;
  latestConsultationAt?: Resolver<Maybe<GQLResolversTypes['Date']>, ParentType, ContextType>;
  medicalInstitutionId?: Resolver<GQLResolversTypes['String'], ParentType, ContextType>;
  medicalInstitutionName?: Resolver<GQLResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<Maybe<GQLResolversTypes['String']>, ParentType, ContextType>;
  nickname?: Resolver<Maybe<GQLResolversTypes['String']>, ParentType, ContextType>;
  pdtCode?: Resolver<Maybe<GQLResolversTypes['String']>, ParentType, ContextType>;
  pdtId?: Resolver<Maybe<GQLResolversTypes['String']>, ParentType, ContextType>;
  prescribedAt?: Resolver<Maybe<GQLResolversTypes['Date']>, ParentType, ContextType>;
  prescriptionCode?: Resolver<GQLResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<GQLResolversTypes['String'], ParentType, ContextType>;
};

export interface GQLJsonScalarConfig extends GraphQLScalarTypeConfig<GQLResolversTypes['Json'], any> {
  name: 'Json';
}

export type GQLListHtUserResolvers<ContextType = any, ParentType extends GQLResolversParentTypes['ListHTUser'] = GQLResolversParentTypes['ListHTUser']> = {
  appName?: Resolver<GQLResolversTypes['String'], ParentType, ContextType>;
  birthday?: Resolver<Maybe<GQLResolversTypes['Date']>, ParentType, ContextType>;
  bloodPressureMeasurementRate?: Resolver<Maybe<GQLResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<Maybe<GQLResolversTypes['Date']>, ParentType, ContextType>;
  email?: Resolver<Maybe<GQLResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<GQLResolversTypes['ID'], ParentType, ContextType>;
  medicalInstitutionId?: Resolver<Maybe<GQLResolversTypes['String']>, ParentType, ContextType>;
  medicalInstitutionName?: Resolver<Maybe<GQLResolversTypes['String']>, ParentType, ContextType>;
  nickname?: Resolver<Maybe<GQLResolversTypes['String']>, ParentType, ContextType>;
  pdtCode?: Resolver<Maybe<GQLResolversTypes['String']>, ParentType, ContextType>;
  pdtId?: Resolver<Maybe<GQLResolversTypes['String']>, ParentType, ContextType>;
  prescribedAt?: Resolver<Maybe<GQLResolversTypes['Date']>, ParentType, ContextType>;
  prescriptionCode?: Resolver<GQLResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<GQLResolversTypes['String'], ParentType, ContextType>;
};

export type GQLListHaudyUserResolvers<ContextType = any, ParentType extends GQLResolversParentTypes['ListHaudyUser'] = GQLResolversParentTypes['ListHaudyUser']> = {
  activatedAt?: Resolver<Maybe<GQLResolversTypes['Date']>, ParentType, ContextType>;
  appName?: Resolver<GQLResolversTypes['String'], ParentType, ContextType>;
  birthMonth?: Resolver<Maybe<GQLResolversTypes['Date']>, ParentType, ContextType>;
  firstConsultationAt?: Resolver<Maybe<GQLResolversTypes['Date']>, ParentType, ContextType>;
  id?: Resolver<GQLResolversTypes['ID'], ParentType, ContextType>;
  latestConsultationAt?: Resolver<Maybe<GQLResolversTypes['Date']>, ParentType, ContextType>;
  nickname?: Resolver<Maybe<GQLResolversTypes['String']>, ParentType, ContextType>;
  pdtCode?: Resolver<Maybe<GQLResolversTypes['String']>, ParentType, ContextType>;
  pdtId?: Resolver<Maybe<GQLResolversTypes['String']>, ParentType, ContextType>;
  prescribedAt?: Resolver<Maybe<GQLResolversTypes['Date']>, ParentType, ContextType>;
  prescriptionCode?: Resolver<GQLResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<GQLResolversTypes['String'], ParentType, ContextType>;
};

export type GQLListScUserResolvers<ContextType = any, ParentType extends GQLResolversParentTypes['ListSCUser'] = GQLResolversParentTypes['ListSCUser']> = {
  appName?: Resolver<GQLResolversTypes['String'], ParentType, ContextType>;
  birthday?: Resolver<Maybe<GQLResolversTypes['Date']>, ParentType, ContextType>;
  coCheckerSerial?: Resolver<Maybe<GQLResolversTypes['String']>, ParentType, ContextType>;
  email?: Resolver<Maybe<GQLResolversTypes['String']>, ParentType, ContextType>;
  firstName?: Resolver<Maybe<GQLResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<GQLResolversTypes['ID'], ParentType, ContextType>;
  lastName?: Resolver<Maybe<GQLResolversTypes['String']>, ParentType, ContextType>;
  phoneNumber?: Resolver<Maybe<GQLResolversTypes['String']>, ParentType, ContextType>;
  prescribedAt?: Resolver<Maybe<GQLResolversTypes['Date']>, ParentType, ContextType>;
  prescriptionCode?: Resolver<GQLResolversTypes['String'], ParentType, ContextType>;
  registeredAt?: Resolver<Maybe<GQLResolversTypes['Date']>, ParentType, ContextType>;
};

export type GQLMedicalInstitutionResolvers<ContextType = any, ParentType extends GQLResolversParentTypes['MedicalInstitution'] = GQLResolversParentTypes['MedicalInstitution']> = {
  city?: Resolver<GQLResolversTypes['String'], ParentType, ContextType>;
  createdAt?: Resolver<GQLResolversTypes['Date'], ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<GQLResolversTypes['Date']>, ParentType, ContextType>;
  id?: Resolver<GQLResolversTypes['ID'], ParentType, ContextType>;
  isDummy?: Resolver<Maybe<GQLResolversTypes['Boolean']>, ParentType, ContextType>;
  name?: Resolver<GQLResolversTypes['String'], ParentType, ContextType>;
  otherAddress?: Resolver<GQLResolversTypes['String'], ParentType, ContextType>;
  phoneNumber?: Resolver<GQLResolversTypes['String'], ParentType, ContextType>;
  postalCode?: Resolver<GQLResolversTypes['String'], ParentType, ContextType>;
  prefecture?: Resolver<GQLResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<GQLResolversTypes['Date'], ParentType, ContextType>;
};

export type GQLMedicalInstitutionDetailResolvers<ContextType = any, ParentType extends GQLResolversParentTypes['MedicalInstitutionDetail'] = GQLResolversParentTypes['MedicalInstitutionDetail']> = {
  billingAccount?: Resolver<Maybe<GQLResolversTypes['BillingAccount']>, ParentType, ContextType>;
  city?: Resolver<GQLResolversTypes['String'], ParentType, ContextType>;
  clientCertificate?: Resolver<GQLResolversTypes['ClientCertificate'], ParentType, ContextType>;
  createdAt?: Resolver<GQLResolversTypes['Date'], ParentType, ContextType>;
  deletedAt?: Resolver<Maybe<GQLResolversTypes['Date']>, ParentType, ContextType>;
  id?: Resolver<GQLResolversTypes['ID'], ParentType, ContextType>;
  isDummy?: Resolver<Maybe<GQLResolversTypes['Boolean']>, ParentType, ContextType>;
  isSetupFinished?: Resolver<GQLResolversTypes['Boolean'], ParentType, ContextType>;
  name?: Resolver<GQLResolversTypes['String'], ParentType, ContextType>;
  otherAddress?: Resolver<GQLResolversTypes['String'], ParentType, ContextType>;
  phoneNumber?: Resolver<GQLResolversTypes['String'], ParentType, ContextType>;
  postalCode?: Resolver<GQLResolversTypes['String'], ParentType, ContextType>;
  prefecture?: Resolver<GQLResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<GQLResolversTypes['Date'], ParentType, ContextType>;
};

export type GQLMedicalInstitutionMemberResolvers<ContextType = any, ParentType extends GQLResolversParentTypes['MedicalInstitutionMember'] = GQLResolversParentTypes['MedicalInstitutionMember']> = {
  contracts?: Resolver<Maybe<Array<GQLResolversTypes['MemberContract']>>, ParentType, ContextType>;
  createdAt?: Resolver<GQLResolversTypes['Date'], ParentType, ContextType>;
  id?: Resolver<GQLResolversTypes['ID'], ParentType, ContextType>;
  medicalInstitution?: Resolver<GQLResolversTypes['MedicalInstitution'], ParentType, ContextType>;
  name?: Resolver<GQLResolversTypes['String'], ParentType, ContextType>;
  position?: Resolver<Array<GQLResolversTypes['MedicalInstitutionMemberPosition']>, ParentType, ContextType>;
  role?: Resolver<Array<GQLResolversTypes['MedicalInstitutionMemberRole']>, ParentType, ContextType>;
  status?: Resolver<GQLResolversTypes['MedicalInstitutionMemberStatus'], ParentType, ContextType>;
};

export type GQLMemberContractResolvers<ContextType = any, ParentType extends GQLResolversParentTypes['MemberContract'] = GQLResolversParentTypes['MemberContract']> = {
  id?: Resolver<GQLResolversTypes['ID'], ParentType, ContextType>;
  pdt?: Resolver<GQLResolversTypes['Pdt'], ParentType, ContextType>;
};

export type GQLMutationResolvers<ContextType = any, ParentType extends GQLResolversParentTypes['Mutation'] = GQLResolversParentTypes['Mutation']> = {
  cancelContract?: Resolver<GQLResolversTypes['CancelContractPayload'], ParentType, ContextType, RequireFields<GQLMutationCancelContractArgs, 'input'>>;
  cancelMedicalInstitution?: Resolver<GQLResolversTypes['CancelMedicalInstitutionPayload'], ParentType, ContextType, RequireFields<GQLMutationCancelMedicalInstitutionArgs, 'input'>>;
  createCsNotification?: Resolver<GQLResolversTypes['CsNotificationPayload'], ParentType, ContextType, RequireFields<GQLMutationCreateCsNotificationArgs, 'input'>>;
  createCsNotificationImageUploadUrl?: Resolver<GQLResolversTypes['CreateCsNotificationImageUploadUrlPayload'], ParentType, ContextType, RequireFields<GQLMutationCreateCsNotificationImageUploadUrlArgs, 'input'>>;
  createDeliveryOrder?: Resolver<GQLResolversTypes['DeliveryOrder'], ParentType, ContextType, RequireFields<GQLMutationCreateDeliveryOrderArgs, 'input'>>;
  createPdtDocument?: Resolver<GQLResolversTypes['PdtDocument'], ParentType, ContextType, RequireFields<GQLMutationCreatePdtDocumentArgs, 'input'>>;
  deleteCsNotification?: Resolver<GQLResolversTypes['DeleteCsNotificationPayload'], ParentType, ContextType, RequireFields<GQLMutationDeleteCsNotificationArgs, 'id'>>;
  forceCancelPrescription?: Resolver<Maybe<GQLResolversTypes['ForceCancelPrescriptionPayload']>, ParentType, ContextType, RequireFields<GQLMutationForceCancelPrescriptionArgs, 'input'>>;
  noop?: Resolver<Maybe<GQLResolversTypes['NoopPayload']>, ParentType, ContextType, Partial<GQLMutationNoopArgs>>;
  publishHtVerifyCode?: Resolver<GQLResolversTypes['HTVerifyCode'], ParentType, ContextType, RequireFields<GQLMutationPublishHtVerifyCodeArgs, 'input'>>;
  reissueSecretCode?: Resolver<GQLResolversTypes['ReissueSecretCodePayload'], ParentType, ContextType, RequireFields<GQLMutationReissueSecretCodeArgs, 'medicalInstitutionMemberId'>>;
  resendWelcomeMail?: Resolver<GQLResolversTypes['ResendWelcomeMailPayload'], ParentType, ContextType, RequireFields<GQLMutationResendWelcomeMailArgs, 'input'>>;
  resendWelcomeMailV2?: Resolver<GQLResolversTypes['ResendWelcomeMailV2Payload'], ParentType, ContextType, RequireFields<GQLMutationResendWelcomeMailV2Args, 'input'>>;
  sendUpdatePasswordCompletionEmail?: Resolver<Maybe<GQLResolversTypes['Boolean']>, ParentType, ContextType, RequireFields<GQLMutationSendUpdatePasswordCompletionEmailArgs, 'input'>>;
  updateCsNotification?: Resolver<GQLResolversTypes['CsNotificationPayload'], ParentType, ContextType, RequireFields<GQLMutationUpdateCsNotificationArgs, 'input'>>;
  updateHtUserEmailAddress?: Resolver<GQLResolversTypes['HTUser'], ParentType, ContextType, RequireFields<GQLMutationUpdateHtUserEmailAddressArgs, 'input'>>;
  uploadPdtDocument?: Resolver<GQLResolversTypes['PdtDocument'], ParentType, ContextType, RequireFields<GQLMutationUploadPdtDocumentArgs, 'input'>>;
};

export type GQLNodeResolvers<ContextType = any, ParentType extends GQLResolversParentTypes['Node'] = GQLResolversParentTypes['Node']> = {
  __resolveType: TypeResolveFn<null, ParentType, ContextType>;
};

export type GQLNoopPayloadResolvers<ContextType = any, ParentType extends GQLResolversParentTypes['NoopPayload'] = GQLResolversParentTypes['NoopPayload']> = {
  clientMutationId?: Resolver<Maybe<GQLResolversTypes['String']>, ParentType, ContextType>;
};

export type GQLOrderClassResolvers<ContextType = any, ParentType extends GQLResolversParentTypes['OrderClass'] = GQLResolversParentTypes['OrderClass']> = {
  code?: Resolver<GQLResolversTypes['OrderClassCode'], ParentType, ContextType>;
  name?: Resolver<GQLResolversTypes['String'], ParentType, ContextType>;
};

export type GQLPdtResolvers<ContextType = any, ParentType extends GQLResolversParentTypes['Pdt'] = GQLResolversParentTypes['Pdt']> = {
  category?: Resolver<Maybe<GQLResolversTypes['String']>, ParentType, ContextType>;
  createdAt?: Resolver<GQLResolversTypes['Date'], ParentType, ContextType>;
  description?: Resolver<GQLResolversTypes['String'], ParentType, ContextType>;
  enableFlag?: Resolver<GQLResolversTypes['Boolean'], ParentType, ContextType>;
  hasTentativePrescriptions?: Resolver<GQLResolversTypes['Boolean'], ParentType, ContextType>;
  iconPath?: Resolver<GQLResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<GQLResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<GQLResolversTypes['String'], ParentType, ContextType>;
  officialUrl?: Resolver<GQLResolversTypes['String'], ParentType, ContextType>;
  pdtDocuments?: Resolver<Array<GQLResolversTypes['PdtDocument']>, ParentType, ContextType>;
  siteUrl?: Resolver<GQLResolversTypes['String'], ParentType, ContextType>;
  supportUrl?: Resolver<GQLResolversTypes['String'], ParentType, ContextType>;
  vendor?: Resolver<GQLResolversTypes['Vendor'], ParentType, ContextType>;
};

export type GQLPdtDocumentResolvers<ContextType = any, ParentType extends GQLResolversParentTypes['PdtDocument'] = GQLResolversParentTypes['PdtDocument']> = {
  createdAt?: Resolver<GQLResolversTypes['Date'], ParentType, ContextType>;
  enableFlag?: Resolver<GQLResolversTypes['Boolean'], ParentType, ContextType>;
  id?: Resolver<GQLResolversTypes['ID'], ParentType, ContextType>;
  isUrlS3Path?: Resolver<GQLResolversTypes['Boolean'], ParentType, ContextType>;
  name?: Resolver<GQLResolversTypes['String'], ParentType, ContextType>;
  url?: Resolver<GQLResolversTypes['String'], ParentType, ContextType>;
  version?: Resolver<GQLResolversTypes['Int'], ParentType, ContextType>;
};

export type GQLPrescriptionResolvers<ContextType = any, ParentType extends GQLResolversParentTypes['Prescription'] = GQLResolversParentTypes['Prescription']> = {
  id?: Resolver<GQLResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<Maybe<GQLResolversTypes['String']>, ParentType, ContextType>;
  prescriptionCureAppPdtCode?: Resolver<Maybe<GQLResolversTypes['PrescriptionCureAppPdtCode']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQLPrescriptionByPrescriptionCodePayloadResolvers<ContextType = any, ParentType extends GQLResolversParentTypes['PrescriptionByPrescriptionCodePayload'] = GQLResolversParentTypes['PrescriptionByPrescriptionCodePayload']> = {
  appName?: Resolver<GQLResolversTypes['String'], ParentType, ContextType>;
  birthday?: Resolver<Maybe<GQLResolversTypes['Date']>, ParentType, ContextType>;
  code?: Resolver<GQLResolversTypes['String'], ParentType, ContextType>;
  codeId?: Resolver<GQLResolversTypes['String'], ParentType, ContextType>;
  codeStatus?: Resolver<GQLResolversTypes['PrescriptionCodeStatusLabelForCsSystem'], ParentType, ContextType>;
  createdAt?: Resolver<Maybe<GQLResolversTypes['Date']>, ParentType, ContextType>;
  id?: Resolver<GQLResolversTypes['ID'], ParentType, ContextType>;
  medicalInstitutionName?: Resolver<GQLResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<Maybe<GQLResolversTypes['String']>, ParentType, ContextType>;
};

export type GQLPrescriptionCureAppPdtCodeResolvers<ContextType = any, ParentType extends GQLResolversParentTypes['PrescriptionCureAppPdtCode'] = GQLResolversParentTypes['PrescriptionCureAppPdtCode']> = {
  activationLimit?: Resolver<Maybe<GQLResolversTypes['String']>, ParentType, ContextType>;
  canceledStatus?: Resolver<Maybe<GQLResolversTypes['Boolean']>, ParentType, ContextType>;
  id?: Resolver<GQLResolversTypes['ID'], ParentType, ContextType>;
  pdtCode?: Resolver<Maybe<GQLResolversTypes['String']>, ParentType, ContextType>;
  pdtCodeId?: Resolver<GQLResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<Maybe<GQLResolversTypes['String']>, ParentType, ContextType>;
  statusLabel?: Resolver<Maybe<GQLResolversTypes['PrescriptionCodeStatusLabel']>, ParentType, ContextType>;
  statusLabelForCsSystem?: Resolver<Maybe<GQLResolversTypes['PrescriptionCodeStatusLabelForCsSystem']>, ParentType, ContextType>;
};

export type GQLPrescriptionWithDeletedByPrescriptionCodeIdPayloadResolvers<ContextType = any, ParentType extends GQLResolversParentTypes['PrescriptionWithDeletedByPrescriptionCodeIdPayload'] = GQLResolversParentTypes['PrescriptionWithDeletedByPrescriptionCodeIdPayload']> = {
  birthday?: Resolver<Maybe<GQLResolversTypes['Date']>, ParentType, ContextType>;
  contract?: Resolver<GQLResolversTypes['Contract'], ParentType, ContextType>;
  createdAt?: Resolver<Maybe<GQLResolversTypes['Date']>, ParentType, ContextType>;
  id?: Resolver<GQLResolversTypes['ID'], ParentType, ContextType>;
  medicalInstitutionMember?: Resolver<GQLResolversTypes['MedicalInstitutionMember'], ParentType, ContextType>;
  name?: Resolver<Maybe<GQLResolversTypes['String']>, ParentType, ContextType>;
  prescriptionCureAppPdtCode?: Resolver<Maybe<GQLResolversTypes['PrescriptionCureAppPdtCode']>, ParentType, ContextType>;
};

export type GQLProductResolvers<ContextType = any, ParentType extends GQLResolversParentTypes['Product'] = GQLResolversParentTypes['Product']> = {
  code?: Resolver<GQLResolversTypes['String'], ParentType, ContextType>;
  description?: Resolver<GQLResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<GQLResolversTypes['String'], ParentType, ContextType>;
  productClass?: Resolver<GQLResolversTypes['ProductClass'], ParentType, ContextType>;
  productSets?: Resolver<Array<GQLResolversTypes['ProductSet']>, ParentType, ContextType>;
  receiptClass?: Resolver<GQLResolversTypes['ReceiptClass'], ParentType, ContextType>;
  shippingDeadlineAdjustmentClass?: Resolver<GQLResolversTypes['ShippingDeadlineAdjustmentClass'], ParentType, ContextType>;
  shippingDeadlineManagementClass?: Resolver<GQLResolversTypes['ShippingDeadlineManagementClass'], ParentType, ContextType>;
  shippingDeadlineOffsetPeriod?: Resolver<GQLResolversTypes['Int'], ParentType, ContextType>;
  stockManagementClass?: Resolver<GQLResolversTypes['StockManagementClass'], ParentType, ContextType>;
  unitSize?: Resolver<GQLResolversTypes['Int'], ParentType, ContextType>;
};

export type GQLProductClassResolvers<ContextType = any, ParentType extends GQLResolversParentTypes['ProductClass'] = GQLResolversParentTypes['ProductClass']> = {
  code?: Resolver<GQLResolversTypes['ProductClassCode'], ParentType, ContextType>;
};

export type GQLProductSetResolvers<ContextType = any, ParentType extends GQLResolversParentTypes['ProductSet'] = GQLResolversParentTypes['ProductSet']> = {
  childProduct?: Resolver<GQLResolversTypes['Product'], ParentType, ContextType>;
  product?: Resolver<GQLResolversTypes['Product'], ParentType, ContextType>;
};

export type GQLQueryResolvers<ContextType = any, ParentType extends GQLResolversParentTypes['Query'] = GQLResolversParentTypes['Query']> = {
  clientCertificate?: Resolver<Maybe<GQLResolversTypes['ClientCertificate']>, ParentType, ContextType, RequireFields<GQLQueryClientCertificateArgs, 'domain'>>;
  contracts?: Resolver<Array<GQLResolversTypes['Contract']>, ParentType, ContextType, RequireFields<GQLQueryContractsArgs, 'medicalInstitutionId'>>;
  contractsIncludingCanceled?: Resolver<Array<GQLResolversTypes['Contract']>, ParentType, ContextType, RequireFields<GQLQueryContractsIncludingCanceledArgs, 'medicalInstitutionId'>>;
  csNotification?: Resolver<GQLResolversTypes['CsNotification'], ParentType, ContextType, RequireFields<GQLQueryCsNotificationArgs, 'id'>>;
  csNotifications?: Resolver<GQLResolversTypes['CsNotificationsPayload'], ParentType, ContextType, Partial<GQLQueryCsNotificationsArgs>>;
  deliveryOrder?: Resolver<Maybe<GQLResolversTypes['DeliveryOrder']>, ParentType, ContextType, RequireFields<GQLQueryDeliveryOrderArgs, 'id'>>;
  deliveryOrders?: Resolver<Array<GQLResolversTypes['DeliveryOrder']>, ParentType, ContextType, Partial<GQLQueryDeliveryOrdersArgs>>;
  deliveryOrdersWithKeywords?: Resolver<Array<GQLResolversTypes['DeliveryOrder']>, ParentType, ContextType, RequireFields<GQLQueryDeliveryOrdersWithKeywordsArgs, 'keywords'>>;
  emailContactSummariesByMedicalInstitutionId?: Resolver<Array<GQLResolversTypes['EmailContactSummary']>, ParentType, ContextType, RequireFields<GQLQueryEmailContactSummariesByMedicalInstitutionIdArgs, 'id'>>;
  haudyUser?: Resolver<Maybe<GQLResolversTypes['HaudyUser']>, ParentType, ContextType, RequireFields<GQLQueryHaudyUserArgs, 'id'>>;
  haudyUsers?: Resolver<Array<GQLResolversTypes['ListHaudyUser']>, ParentType, ContextType, Partial<GQLQueryHaudyUsersArgs>>;
  htUser?: Resolver<GQLResolversTypes['HTUser'], ParentType, ContextType, RequireFields<GQLQueryHtUserArgs, 'id'>>;
  htUsers?: Resolver<Array<GQLResolversTypes['ListHTUser']>, ParentType, ContextType, Partial<GQLQueryHtUsersArgs>>;
  medicalInstitutionDetail?: Resolver<Maybe<GQLResolversTypes['MedicalInstitutionDetail']>, ParentType, ContextType, RequireFields<GQLQueryMedicalInstitutionDetailArgs, 'medicalInstitutionId'>>;
  medicalInstitutionMembersByMedicalInstitutionId?: Resolver<Array<GQLResolversTypes['MedicalInstitutionMember']>, ParentType, ContextType, RequireFields<GQLQueryMedicalInstitutionMembersByMedicalInstitutionIdArgs, 'medicalInstitutionId'>>;
  medicalInstitutions?: Resolver<Array<GQLResolversTypes['MedicalInstitution']>, ParentType, ContextType, Partial<GQLQueryMedicalInstitutionsArgs>>;
  node?: Resolver<Maybe<GQLResolversTypes['Node']>, ParentType, ContextType, RequireFields<GQLQueryNodeArgs, 'id'>>;
  pdt?: Resolver<GQLResolversTypes['Pdt'], ParentType, ContextType, RequireFields<GQLQueryPdtArgs, 'id'>>;
  pdts?: Resolver<Array<GQLResolversTypes['Pdt']>, ParentType, ContextType>;
  prescriptionByPrescriptionCode?: Resolver<Maybe<GQLResolversTypes['PrescriptionByPrescriptionCodePayload']>, ParentType, ContextType, RequireFields<GQLQueryPrescriptionByPrescriptionCodeArgs, 'prescriptionCode'>>;
  prescriptionWithDeletedByPrescriptionCodeId?: Resolver<Maybe<GQLResolversTypes['PrescriptionWithDeletedByPrescriptionCodeIdPayload']>, ParentType, ContextType, RequireFields<GQLQueryPrescriptionWithDeletedByPrescriptionCodeIdArgs, 'prescriptionCodeId'>>;
  previewCsNotificationMarkdown?: Resolver<GQLResolversTypes['String'], ParentType, ContextType, RequireFields<GQLQueryPreviewCsNotificationMarkdownArgs, 'body'>>;
  products?: Resolver<Array<GQLResolversTypes['Product']>, ParentType, ContextType>;
  scUser?: Resolver<GQLResolversTypes['SCUser'], ParentType, ContextType, RequireFields<GQLQueryScUserArgs, 'id'>>;
  scUsers?: Resolver<Array<GQLResolversTypes['ListSCUser']>, ParentType, ContextType, Partial<GQLQueryScUsersArgs>>;
};

export type GQLReceiptClassResolvers<ContextType = any, ParentType extends GQLResolversParentTypes['ReceiptClass'] = GQLResolversParentTypes['ReceiptClass']> = {
  code?: Resolver<GQLResolversTypes['ReceiptClassCode'], ParentType, ContextType>;
  name?: Resolver<GQLResolversTypes['String'], ParentType, ContextType>;
};

export type GQLReissueSecretCodePayloadResolvers<ContextType = any, ParentType extends GQLResolversParentTypes['ReissueSecretCodePayload'] = GQLResolversParentTypes['ReissueSecretCodePayload']> = {
  secretCode?: Resolver<GQLResolversTypes['String'], ParentType, ContextType>;
};

export type GQLResendWelcomeMailFailureResolvers<ContextType = any, ParentType extends GQLResolversParentTypes['ResendWelcomeMailFailure'] = GQLResolversParentTypes['ResendWelcomeMailFailure']> = {
  message?: Resolver<GQLResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQLResendWelcomeMailPayloadResolvers<ContextType = any, ParentType extends GQLResolversParentTypes['ResendWelcomeMailPayload'] = GQLResolversParentTypes['ResendWelcomeMailPayload']> = {
  __resolveType: TypeResolveFn<'ResendWelcomeMailFailure' | 'ResendWelcomeMailSuccess', ParentType, ContextType>;
};

export type GQLResendWelcomeMailSuccessResolvers<ContextType = any, ParentType extends GQLResolversParentTypes['ResendWelcomeMailSuccess'] = GQLResolversParentTypes['ResendWelcomeMailSuccess']> = {
  contract?: Resolver<GQLResolversTypes['Contract'], ParentType, ContextType>;
  resendEmailAddress?: Resolver<GQLResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQLResendWelcomeMailV2FailureResolvers<ContextType = any, ParentType extends GQLResolversParentTypes['ResendWelcomeMailV2Failure'] = GQLResolversParentTypes['ResendWelcomeMailV2Failure']> = {
  message?: Resolver<GQLResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQLResendWelcomeMailV2PayloadResolvers<ContextType = any, ParentType extends GQLResolversParentTypes['ResendWelcomeMailV2Payload'] = GQLResolversParentTypes['ResendWelcomeMailV2Payload']> = {
  __resolveType: TypeResolveFn<'ResendWelcomeMailV2Failure' | 'ResendWelcomeMailV2Success', ParentType, ContextType>;
};

export type GQLResendWelcomeMailV2SuccessResolvers<ContextType = any, ParentType extends GQLResolversParentTypes['ResendWelcomeMailV2Success'] = GQLResolversParentTypes['ResendWelcomeMailV2Success']> = {
  contract?: Resolver<GQLResolversTypes['Contract'], ParentType, ContextType>;
  resendEmailAddress?: Resolver<GQLResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GQLScUserResolvers<ContextType = any, ParentType extends GQLResolversParentTypes['SCUser'] = GQLResolversParentTypes['SCUser']> = {
  appName?: Resolver<GQLResolversTypes['String'], ParentType, ContextType>;
  birthday?: Resolver<Maybe<GQLResolversTypes['Date']>, ParentType, ContextType>;
  coCheckerSerial?: Resolver<Maybe<GQLResolversTypes['String']>, ParentType, ContextType>;
  email?: Resolver<Maybe<GQLResolversTypes['String']>, ParentType, ContextType>;
  firstName?: Resolver<Maybe<GQLResolversTypes['String']>, ParentType, ContextType>;
  id?: Resolver<GQLResolversTypes['ID'], ParentType, ContextType>;
  lastName?: Resolver<Maybe<GQLResolversTypes['String']>, ParentType, ContextType>;
  medicalInstitutionId?: Resolver<GQLResolversTypes['String'], ParentType, ContextType>;
  medicalInstitutionName?: Resolver<GQLResolversTypes['String'], ParentType, ContextType>;
  phoneNumber?: Resolver<Maybe<GQLResolversTypes['String']>, ParentType, ContextType>;
  prescribedAt?: Resolver<Maybe<GQLResolversTypes['Date']>, ParentType, ContextType>;
  prescription?: Resolver<Maybe<GQLResolversTypes['Prescription']>, ParentType, ContextType>;
  prescriptionCode?: Resolver<GQLResolversTypes['String'], ParentType, ContextType>;
  registeredAt?: Resolver<Maybe<GQLResolversTypes['Date']>, ParentType, ContextType>;
};

export type GQLShippingDeadlineAdjustmentClassResolvers<ContextType = any, ParentType extends GQLResolversParentTypes['ShippingDeadlineAdjustmentClass'] = GQLResolversParentTypes['ShippingDeadlineAdjustmentClass']> = {
  code?: Resolver<GQLResolversTypes['ShippingDeadlineAdjustmentClassCode'], ParentType, ContextType>;
};

export type GQLShippingDeadlineManagementClassResolvers<ContextType = any, ParentType extends GQLResolversParentTypes['ShippingDeadlineManagementClass'] = GQLResolversParentTypes['ShippingDeadlineManagementClass']> = {
  code?: Resolver<GQLResolversTypes['ShippingDeadlineManagementClassCode'], ParentType, ContextType>;
};

export type GQLStockManagementClassResolvers<ContextType = any, ParentType extends GQLResolversParentTypes['StockManagementClass'] = GQLResolversParentTypes['StockManagementClass']> = {
  code?: Resolver<GQLResolversTypes['StockManagementClassCode'], ParentType, ContextType>;
};

export interface GQLUploadScalarConfig extends GraphQLScalarTypeConfig<GQLResolversTypes['Upload'], any> {
  name: 'Upload';
}

export type GQLVendorResolvers<ContextType = any, ParentType extends GQLResolversParentTypes['Vendor'] = GQLResolversParentTypes['Vendor']> = {
  id?: Resolver<GQLResolversTypes['ID'], ParentType, ContextType>;
  name?: Resolver<GQLResolversTypes['String'], ParentType, ContextType>;
};

export type GQLResolvers<ContextType = any> = {
  ActiveContractExistsError?: GQLActiveContractExistsErrorResolvers<ContextType>;
  BillingAccount?: GQLBillingAccountResolvers<ContextType>;
  CancelContractPayload?: GQLCancelContractPayloadResolvers<ContextType>;
  CancelMedicalInstitutionPayload?: GQLCancelMedicalInstitutionPayloadResolvers<ContextType>;
  CancelMedicalInstitutionSuccess?: GQLCancelMedicalInstitutionSuccessResolvers<ContextType>;
  ClientCertificate?: GQLClientCertificateResolvers<ContextType>;
  Contract?: GQLContractResolvers<ContextType>;
  ContractManager?: GQLContractManagerResolvers<ContextType>;
  ContractNotificationRecipient?: GQLContractNotificationRecipientResolvers<ContextType>;
  ContractResponsiblePerson?: GQLContractResponsiblePersonResolvers<ContextType>;
  CreateCsNotificationImageUploadUrlPayload?: GQLCreateCsNotificationImageUploadUrlPayloadResolvers<ContextType>;
  CsNotification?: GQLCsNotificationResolvers<ContextType>;
  CsNotificationImageUploadUrl?: GQLCsNotificationImageUploadUrlResolvers<ContextType>;
  CsNotificationImageUploadUrlError?: GQLCsNotificationImageUploadUrlErrorResolvers<ContextType>;
  CsNotificationPayload?: GQLCsNotificationPayloadResolvers<ContextType>;
  CsNotificationsPayload?: GQLCsNotificationsPayloadResolvers<ContextType>;
  Date?: GraphQLScalarType;
  DeleteCsNotificationError?: GQLDeleteCsNotificationErrorResolvers<ContextType>;
  DeleteCsNotificationPayload?: GQLDeleteCsNotificationPayloadResolvers<ContextType>;
  DeleteCsNotificationSuccess?: GQLDeleteCsNotificationSuccessResolvers<ContextType>;
  DeliveryHistory?: GQLDeliveryHistoryResolvers<ContextType>;
  DeliveryOrder?: GQLDeliveryOrderResolvers<ContextType>;
  DeliveryOrderField?: GQLDeliveryOrderFieldResolvers<ContextType>;
  DeliveryProducts?: GQLDeliveryProductsResolvers<ContextType>;
  DeliveryStatus?: GQLDeliveryStatusResolvers<ContextType>;
  DeliveryTime?: GQLDeliveryTimeResolvers<ContextType>;
  EmailContact?: GQLEmailContactResolvers<ContextType>;
  EmailContactPdt?: GQLEmailContactPdtResolvers<ContextType>;
  EmailContactSummary?: GQLEmailContactSummaryResolvers<ContextType>;
  Error?: GQLErrorResolvers<ContextType>;
  ForceCancelPrescriptionError?: GQLForceCancelPrescriptionErrorResolvers<ContextType>;
  ForceCancelPrescriptionPayload?: GQLForceCancelPrescriptionPayloadResolvers<ContextType>;
  HTUser?: GQLHtUserResolvers<ContextType>;
  HTVerifyCode?: GQLHtVerifyCodeResolvers<ContextType>;
  HaudyUser?: GQLHaudyUserResolvers<ContextType>;
  Json?: GraphQLScalarType;
  ListHTUser?: GQLListHtUserResolvers<ContextType>;
  ListHaudyUser?: GQLListHaudyUserResolvers<ContextType>;
  ListSCUser?: GQLListScUserResolvers<ContextType>;
  MedicalInstitution?: GQLMedicalInstitutionResolvers<ContextType>;
  MedicalInstitutionDetail?: GQLMedicalInstitutionDetailResolvers<ContextType>;
  MedicalInstitutionMember?: GQLMedicalInstitutionMemberResolvers<ContextType>;
  MemberContract?: GQLMemberContractResolvers<ContextType>;
  Mutation?: GQLMutationResolvers<ContextType>;
  Node?: GQLNodeResolvers<ContextType>;
  NoopPayload?: GQLNoopPayloadResolvers<ContextType>;
  OrderClass?: GQLOrderClassResolvers<ContextType>;
  Pdt?: GQLPdtResolvers<ContextType>;
  PdtDocument?: GQLPdtDocumentResolvers<ContextType>;
  Prescription?: GQLPrescriptionResolvers<ContextType>;
  PrescriptionByPrescriptionCodePayload?: GQLPrescriptionByPrescriptionCodePayloadResolvers<ContextType>;
  PrescriptionCureAppPdtCode?: GQLPrescriptionCureAppPdtCodeResolvers<ContextType>;
  PrescriptionWithDeletedByPrescriptionCodeIdPayload?: GQLPrescriptionWithDeletedByPrescriptionCodeIdPayloadResolvers<ContextType>;
  Product?: GQLProductResolvers<ContextType>;
  ProductClass?: GQLProductClassResolvers<ContextType>;
  ProductSet?: GQLProductSetResolvers<ContextType>;
  Query?: GQLQueryResolvers<ContextType>;
  ReceiptClass?: GQLReceiptClassResolvers<ContextType>;
  ReissueSecretCodePayload?: GQLReissueSecretCodePayloadResolvers<ContextType>;
  ResendWelcomeMailFailure?: GQLResendWelcomeMailFailureResolvers<ContextType>;
  ResendWelcomeMailPayload?: GQLResendWelcomeMailPayloadResolvers<ContextType>;
  ResendWelcomeMailSuccess?: GQLResendWelcomeMailSuccessResolvers<ContextType>;
  ResendWelcomeMailV2Failure?: GQLResendWelcomeMailV2FailureResolvers<ContextType>;
  ResendWelcomeMailV2Payload?: GQLResendWelcomeMailV2PayloadResolvers<ContextType>;
  ResendWelcomeMailV2Success?: GQLResendWelcomeMailV2SuccessResolvers<ContextType>;
  SCUser?: GQLScUserResolvers<ContextType>;
  ShippingDeadlineAdjustmentClass?: GQLShippingDeadlineAdjustmentClassResolvers<ContextType>;
  ShippingDeadlineManagementClass?: GQLShippingDeadlineManagementClassResolvers<ContextType>;
  StockManagementClass?: GQLStockManagementClassResolvers<ContextType>;
  Upload?: GraphQLScalarType;
  Vendor?: GQLVendorResolvers<ContextType>;
};

